<template>
    <div class="row my-1 justify-content-center">
        <!-- Card 1.1 -->
        <div class="col-md-6 col-sm-6 col-lg-3 m-3 d-flex justify-content-center">
            <CardBordes @click="openModalFinanciamientoCorporativo" id="card-financiamiento2022" minHeight="276px"
                maxHeight="276px" minWidth="261px" maxWidth="261px" borderRadius="30px 0px 30px 0px">

                <template #contenido>
                    <svg id="uuid-5ea90618-a918-4719-ac61-74655a7a3ac7" data-name="Capa 2"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.81 407.93">
                        <g id="uuid-d39be644-4d76-4c2b-bd03-33369b2a8c24" data-name="Capa 1">
                            <g>
                                <path class="uuid-2e7059b9-b1f4-4ddf-bb8d-b3d3d801ef68"
                                    d="m90.25,0h294.56v317.67c0,49.81-40.44,90.25-90.25,90.25H0V90.25C0,40.44,40.44,0,90.25,0Z" />
                                <text class="uuid-c89035a2-9002-4905-aa50-0ac7b8a16920" transform="translate(31.12 72.13)">
                                    <tspan x="0" y="0">Financiamiento </tspan>
                                    <tspan x="-11.32" y="55.87">corpo</tspan>
                                    <tspan class="uuid-f96e77b3-d705-404d-9e8e-481c749e714e" x="104.48" y="55.87">r
                                    </tspan>
                                    <tspan x="123.2" y="55.87">ati</tspan>
                                    <tspan class="uuid-699c3146-2f27-41a1-a053-2b44a4dcd9cd" x="174.55" y="55.87">v
                                    </tspan>
                                    <tspan x="197.13" y="55.87">o 2022</tspan>
                                </text>
                                <polyline class="uuid-15a6d177-0c65-4b24-b5f8-e6000ad4c278"
                                    points="173.98 358.66 193.63 379.62 210.83 358.66" />
                                <g>
                                    <path class="uuid-78127f83-a1e4-46c4-9b10-fa16ca637779"
                                        d="m143.85,339.92c-1.06-.93-2.18-1.8-3.17-2.79-12.45-12.52-24.89-25.05-37.32-37.59-2.67-2.69-2.68-4.26-.05-6.89,5.14-5.16,10.31-10.3,15.42-15.49,2.51-2.55,5.43-3.9,9.05-3.74.55.02,1.38-.4,1.64-.86,11.81-20.72,37.63-25.81,56.17-18.68.91.35,1.95.5,2.93.5,12.15.03,24.29.08,36.44,0,4.95-.03,9.22,1.31,13.11,5.84.35-.71.52-1.42.95-1.87,6.75-6.99,13.51-13.97,20.31-20.91,6.71-6.84,18.17-5.17,22.68,3.25,2.49,4.65,1.68,11.87-1.89,16.17-6.55,7.88-13.14,15.73-19.72,23.59-3.38,4.04-6.81,8.05-10.14,12.14-6.41,7.89-14.81,11.61-24.83,11.68-15.35.1-30.69.16-46.04-.04-5.29-.07-8.55,2.89-11.76,6.28-.24.26-.23.88-.15,1.29.8,4.17-.3,7.69-3.36,10.67-5.39,5.25-10.72,10.56-16.09,15.83-.62.61-1.37,1.1-2.05,1.65h-2.13Zm18.93-35.02c.21-.08.34-.09.42-.16.4-.35.82-.69,1.17-1.08,4.37-4.76,9.74-6.65,16.21-6.56,14.75.2,29.5.08,44.25.06,8.15-.01,14.99-2.86,20.17-9.38,3.09-3.89,6.37-7.65,9.56-11.46,6.73-8.04,13.47-16.07,20.17-24.13,2.66-3.2,2.39-7.43-.51-10.06-2.85-2.58-7.14-2.46-9.93.4-7.62,7.79-15.21,15.62-22.78,23.46-.37.38-.68.99-.69,1.5-.23,9.84-5.91,15.43-15.76,15.43-8.65,0-17.3,0-25.95,0-.71,0-1.43,0-2.12-.12-1.87-.32-3.07-1.8-3-3.6.06-1.8,1.35-3.15,3.26-3.36.65-.07,1.3-.06,1.95-.06,8.71,0,17.42,0,26.13,0,.77,0,1.54-.02,2.3-.12,3.37-.48,5.85-3.21,6.08-6.65.21-3.12-1.96-6.28-5.06-7.13-1.12-.31-2.34-.35-3.52-.35-12.56-.02-25.12,0-37.68-.04-1.16,0-2.4-.14-3.46-.57-7.88-3.23-15.99-3.69-24.23-1.98-10.38,2.15-18.44,7.71-23.95,16.85-.65,1.07-.55,1.69.35,2.54,2.5,2.36,4.89,4.83,7.31,7.26,6.45,6.45,12.89,12.91,19.3,19.33Zm-17.04,26.45c4.52-4.72,9.3-9.65,14-14.65,1.49-1.58,1.21-3.57-.57-5.35-9.76-9.77-19.52-19.53-29.29-29.29-2.08-2.07-3.88-2.06-5.98.03-3.15,3.13-6.26,6.31-9.42,9.43-1.5,1.48-3.07,2.9-4.79,4.52,12.01,11.76,23.73,23.24,36.05,35.3Z" />
                                    <path class="uuid-d1c69a45-16e3-4c5b-ab4b-06985541e2b1"
                                        d="m207.47,235.83c-21.68-.02-39.17-17.57-39.12-39.26.05-21.57,17.6-39.07,39.17-39.06,21.64.01,39.18,17.63,39.12,39.29-.06,21.6-17.57,39.04-39.17,39.02Zm.02-7.12c17.68,0,31.99-14.27,32.03-31.93.04-17.74-14.31-32.14-32.03-32.14-17.64,0-32,14.33-32.03,31.96-.03,17.77,14.28,32.11,32.02,32.11Z" />
                                    <path class="uuid-78127f83-a1e4-46c4-9b10-fa16ca637779"
                                        d="m186.19,278.8c-.04,1.93-1.6,3.48-3.51,3.48-1.94,0-3.62-1.72-3.57-3.64.05-1.97,1.74-3.52,3.73-3.44,1.94.08,3.39,1.65,3.35,3.6Z" />
                                    <path class="uuid-d1c69a45-16e3-4c5b-ab4b-06985541e2b1"
                                        d="m203.23,179.35c0-1.25-.03-2.55,0-3.85.07-2.15,1.54-3.7,3.5-3.73,1.97-.03,3.72,1.52,3.54,3.62-.24,2.74.26,4.75,3.16,5.7.79.26,1.45,1.02,2.07,1.64,1.48,1.47,1.54,3.48.23,4.95-1.25,1.39-3.21,1.56-4.82.42-.72-.51-1.4-1.11-2.16-1.54-1.48-.82-2.97-.79-4.29.37-1.12.98-1.54,2.25-1.06,3.69.55,1.65,1.76,2.39,3.49,2.52,5.49.4,9.27,3.59,10.35,8.62,1.01,4.71-1.28,9.18-5.95,11.78-.44.25-.84.91-.91,1.42-.14,1.05,0,2.13-.06,3.19-.12,2.06-1.59,3.44-3.56,3.43-1.97-.01-3.67-1.44-3.46-3.47.31-2.95-.54-4.79-3.38-5.97-1.28-.53-2.3-1.85-3.24-2.97-1.27-1.53-1.02-3.52.38-4.79,1.41-1.28,3.32-1.26,4.83.07.8.7,1.51,1.52,2.39,2.11,1.48,1,3.1,1.24,4.63.08,1.25-.94,1.74-2.26,1.26-3.78-.57-1.83-1.97-2.51-3.8-2.63-7.91-.54-12.62-8.5-9.15-15.41,1.13-2.25,2.37-3.38,6-5.45Z" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </CardBordes>
        </div>
        <!-- Card 1.2 -->
        <div class="col-md-6 col-sm-6 col-lg-3 m-3 d-flex justify-content-center">
            <CardBordes @click="openModalDirectorios" id="card-directorios" minHeight="276px" maxHeight="276px"
                minWidth="261px" maxWidth="261px" borderRadius="30px 0px 30px 0px">
                <template #contenido>
                    <svg id="uuid-39a178c2-1ede-4a0b-8c49-af379bca068f" data-name="Capa 2"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.81 407.93">
                        <g id="uuid-3de9c8d2-4843-4e35-841b-0446ce8bf003" data-name="Capa 1">
                            <g>
                                <path class="uuid-4d3ded23-06e6-43fc-85fd-e7cbc82d2d74"
                                    d="m90.25,0h294.56v317.67c0,49.81-40.44,90.25-90.25,90.25H0V90.25C0,40.44,40.44,0,90.25,0Z" />
                                <text class="uuid-ddc314bd-0eb1-42c8-bc17-f1f41993118a" transform="translate(83.07 92.08)">
                                    <tspan x="0" y="0">Di</tspan>
                                    <tspan class="uuid-a40202d7-779f-4057-9b25-4a480bb0eca4" x="39.76" y="0">r</tspan>
                                    <tspan x="57.87" y="0">ectorios</tspan>
                                </text>
                                <polyline class="uuid-69ea9095-63a1-4ef2-aaa9-600e8e9f3ced"
                                    points="173.98 358.66 193.63 379.62 210.83 358.66" />
                                <g>
                                    <path class="uuid-8eaf6ed4-d7ff-4a72-9f89-e0ccde568c9a"
                                        d="m298.79,286.13c-1.62,2.16-3.16,2.81-4.83,1.96-1.57-.8-1.87-2.21-1.86-3.85.04-12.46.04-24.93.04-37.39,0-5.69-1.84-8.17-7.29-9.79-4.29-1.27-8.6-2.52-12.88-3.77-3.63,9.88-19.05,9.96-22.96-.13-5.19,1.56-10.48,2.9-15.58,4.76-3.4,1.24-4.66,4.33-4.69,7.87-.03,4.64-.04,9.28-.07,13.92,0,.62.01,1.25-.07,1.87-.23,1.77-1.36,2.75-3.05,2.86-1.71.11-2.97-.8-3.33-2.51-.24-1.13-.19-2.34-.19-3.51,0-4.15,0-8.31.05-12.46.1-7.83,4.06-13.01,11.59-15.23,3.09-.91,6.18-1.81,9.22-3.13-2.23,0-4.46.03-6.69,0-2.42-.04-3.71-1.13-3.71-3.51,0-10.18-.31-20.37.25-30.52.76-13.85,12.68-24.69,26.95-25.29,13.61-.56,26.13,9.61,28.3,23.11.38,2.37.43,4.82.44,7.23.05,8.24.03,16.48.02,24.72,0,3.19-1.05,4.24-4.2,4.26-2.08.01-4.15.01-6.23.02-.07,0-.14.03-.56.12.73.3,1.18.54,1.65.68,2.85.85,5.71,1.65,8.55,2.52,5.68,1.74,9.35,5.43,10.77,11.27.06.25.24.48.36.72v43.22Zm-17-65.27c0-8.52.13-16.82-.03-25.12-.21-11.29-9.33-20.33-20.56-20.62-11.49-.3-21.23,8.08-21.85,19.42-.47,8.55-.16,17.15-.18,25.73,0,.18.15.36.21.48h8c-3.75-4.23-5.06-8.97-4.78-14.23.07-1.38.03-2.77,0-4.15-.05-3.79,1.29-6.95,3.92-9.72,1.6-1.68,3-3.61,4.19-5.6.78-1.29,1.5-2.3,3.09-2.33,1.69-.02,2.72.95,3.25,2.43,1.25,3.47,3.64,5.94,6.94,7.31,3.68,1.53,7.5,2.75,11.31,3.93,1.71.53,3,1.37,3.04,3.18.07,3.17.03,6.36-.21,9.53-.28,3.67-2.14,6.74-4.52,9.75h8.16Zm-27.93-25.95c-3.63,2.52-5.2,5.86-4.63,10.21.17,1.29,0,2.62.05,3.93.21,5.39,4.39,10,9.58,10.6,5.71.66,10.9-2.53,12.34-7.84.5-1.83.34-3.83.57-5.74.16-1.31-.46-1.77-1.63-2.11-6.14-1.8-12.07-4.03-16.29-9.05Zm1.4,31.23c.07,2.54-.77,5.41,2.12,7.2,1.85,1.15,5.15.99,6.72-.28,2.44-1.98,1.34-4.65,1.59-6.92h-10.43Z" />
                                    <path class="uuid-fb2b9782-6f02-4fef-950c-8f8559e1457b"
                                        d="m146.3,302.65c0-5.19-.01-10.39,0-15.58.03-8.22,4.93-14.8,12.82-17.14,5.43-1.61,10.88-3.16,16.35-4.68,1.17-.33,1.83-.81,1.62-2.12-.07-.4-.04-.83,0-1.24.38-4.1-.27-7.59-3.46-10.83-3.37-3.42-4.62-8.11-4.46-13.03.03-1.04-.09-2.09.02-3.11.22-1.99-.42-3.38-1.95-4.84-9-8.62-10.44-21.9-3.51-31.1,4.35-5.78,10.58-7.97,17.44-8.85,8.34-1.07,16.45,0,24.26,3.02,3.69,1.42,6.85,1.55,9.77-1.68,1.54-1.71,3.66-1.17,5.29.99,5.54,7.36,6.86,15.51,4.55,24.37-1.44,5.5-4.64,9.8-8.59,13.72-.73.72-1.11,1.96-1.28,3.02-.22,1.35-.09,2.76-.05,4.15.2,6.26-2.26,11.4-6.41,15.93-.74.81-1.18,2.1-1.29,3.22-.2,2.06.02,4.15-.09,6.23-.07,1.28.4,1.78,1.62,2.12,5.53,1.52,11.04,3.11,16.54,4.76,7.74,2.32,12.56,8.7,12.68,16.8.15,10.73.24,21.47.35,32.2,0,.69.05,1.41-.14,2.06-.49,1.65-1.65,2.58-3.39,2.46-1.72-.12-2.76-1.17-3.06-2.88-.08-.47-.04-.97-.05-1.45-.11-10.59-.22-21.19-.34-31.78-.07-5.92-2.85-9.56-8.55-11.22-4.98-1.44-9.97-2.85-14.94-4.33-1.03-.31-1.75-.44-2.31.8-4.64,10.24-20.43,10.46-26.29.45-.91-1.55-1.73-1.65-3.28-1.17-4.88,1.52-9.82,2.86-14.73,4.28-5.62,1.63-8.52,5.45-8.47,11.29.08,10.32.21,20.63.32,30.95,0,.62.04,1.25-.02,1.87-.21,1.94-1.64,3.27-3.42,3.22-1.81-.05-3.13-1.39-3.18-3.41-.1-4.22-.12-8.45-.17-12.67-.02-1.59,0-3.19,0-4.78-.07,0-.13,0-.2,0Zm70.33-103.84c-3.72,2.6-7.59,2.6-11.59,1.2-1.76-.61-3.52-1.22-5.31-1.76-7.65-2.29-15.37-2.71-23.07-.34-5.8,1.78-9.39,5.72-10.35,11.76-1.02,6.45,1.33,11.71,6.27,16.39,1.41-2.4,2.57-4.66,4.02-6.73.68-.97,1.81-1.93,2.9-2.21.88-.23,2.08.47,3.05.92,7.51,3.51,14.9,5.12,22.21-.61,2.18-1.71,4.85-1.08,6.54,1.26,1.02,1.41,1.72,3.06,2.57,4.6,6.04-5.58,7.41-17.24,2.74-24.48Zm-9.65,25.71c-2.98,1.06-5.68,2.38-8.54,2.97-5.23,1.07-10.33-.07-15.24-1.94-1.48-.56-2.28-.53-3.13.96-.96,1.66-2.3,3.1-3.45,4.66-.31.42-.76.91-.76,1.37-.02,2.77-.23,5.58.18,8.29.97,6.43,8.57,13.63,14.99,14.49.75.1,1.56.17,2.27-.03,7.1-2,12.75-6.08,14.59-13.36,1.45-5.74,1.12-11.82-.92-17.4Zm-23.24,35.77c0,1.73-.04,3.64,0,5.55.09,3.66,3.55,7.28,7.38,7.8,4.62.62,8.07-1.13,9.09-5.22.67-2.71.46-5.63.64-8.27-3.11.69-5.84,1.76-8.58,1.77-2.8.01-5.59-1.02-8.54-1.62Z" />
                                    <path class="uuid-8eaf6ed4-d7ff-4a72-9f89-e0ccde568c9a"
                                        d="m162.5,240.72c-1.13-3.58-3.29-6.45-6.6-8.2-1.5-.79-1.79-1.74-1.78-3.25.05-11.84.09-23.68,0-35.52-.1-13.28-8.94-24.67-21.7-28.16-1.46-.4-2.95-.69-4.42-1.03h-6.65c-.18.09-.35.24-.55.28-16.41,3.27-25.48,14.33-25.48,31.1,0,11.15-.02,22.3.03,33.45,0,1.41-.41,2.18-1.67,2.91-.81.47-1.54.98-2.2,1.52-3.57,2.83-5.41,7.01-5.41,12.46-.02,12.46-.02,24.92-.03,37.38,0,.62-.06,1.27.08,1.86.39,1.67,1.44,2.68,3.2,2.7,1.77.02,2.85-.97,3.27-2.62.17-.65.09-1.38.09-2.07.01-12.24.01-24.48.03-36.71,0-.01,0-.02,0-.03.06-.69.03-1.39.11-2.07.23-2.08.92-3.81,2.11-5.12.64-.67,1.41-1.23,2.32-1.68l-.02-.03c.48-.24.99-.44,1.54-.61,4.3-1.3,8.64-2.48,12.99-3.59.54-.14,1.65.32,1.87.8,3.79,8.12,17.93,8.2,21.92.19.55-1.1,1.15-1.26,2.28-.93,3.91,1.16,7.83,2.28,11.78,3.31,3.26.85,5.51,2.68,6.67,5.91.73,2.03,2.47,2.81,4.29,2.19,1.75-.6,2.55-2.38,1.91-4.42Zm-34.23-7.67c-1.83,1.29-5.56,1.24-7.32-.09-2.85-2.15-1.7-5.22-1.95-7.79h11.42c-.06,2.63.85,5.77-2.15,7.88Zm8.55-30.53c-.33,2.45.03,5.03-.53,7.41-1.31,5.63-6.87,9.44-12.42,8.89-6.15-.61-10.77-5.2-11.18-11.17-.12-1.72-.02-3.45-.02-5,3.55-1.39,7.1-2.45,10.32-4.13,3.2-1.66,6.08-3.94,9.26-6.05,2.94,2.31,5.2,5.43,4.57,10.05Zm10.64,26.41c0,.11-.11.23-.26.51-3.08-.86-6.2-1.72-9.31-2.6-.24-.07-.52-.24-.65-.44-.57-.89.06-5.69.83-6.49,3.57-3.72,5.41-8.14,5.36-13.31-.03-3.11.3-6.32-.36-9.3-.54-2.43-2.17-4.68-3.55-6.86-1.5-2.37-3.4-4.49-4.9-6.86-1.35-2.14-4.69-2.5-5.59-.13-3.02,7.9-9.94,10.28-17,12.08-6.6,1.68-5.89,2.21-6.07,7.94-.2,6.43,1.22,12.07,5.75,16.99,1.06,1.15.39,3.91.44,5.94,0,.15-.54.37-.86.46-2.98.84-5.97,1.65-9.31,2.57,0-3.79-.01-7.24,0-10.7.04-8.79-.26-17.6.21-26.37.65-12.08,10.54-21.11,22.46-21.15,11.91-.04,22.08,8.9,22.65,20.97.57,12.23.16,24.5.17,36.76Z" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </CardBordes>
        </div>
        <!-- Card 1.3 -->
        <div class="col-md-6 col-sm-6 col-lg-3 m-3 d-flex justify-content-center">
            <CardBordes @click="openModalOrganigrama" id="card-organigrama" minHeight="276px" maxHeight="276px"
                minWidth="261px" maxWidth="261px" borderRadius="30px 0px 30px 0px">
                <template #contenido>
                    <svg id="uuid-55070c7e-70e3-429a-9210-4edbc68a07f0" data-name="Capa 2"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.81 407.93">
                        <g id="uuid-b03db268-be69-4d04-bc85-109eca89e91d" data-name="Capa 1">
                            <g>
                                <path class="uuid-90ec77df-f487-4ca1-a17f-013270c6d0c3"
                                    d="m90.25,0h294.56v317.67c0,49.81-40.44,90.25-90.25,90.25H0V90.25C0,40.44,40.44,0,90.25,0Z" />
                                <text class="uuid-2a76059c-8e72-4447-b9db-e4eb1c63edcd" transform="translate(63.14 72.08)">
                                    <tspan x="0" y="0">O</tspan>
                                    <tspan class="uuid-9b315fcd-983d-4e2e-a777-aef0331598a2" x="28.24" y="0">r</tspan>
                                    <tspan class="uuid-c56af774-3681-4842-811d-111494647cd2" x="46.34" y="0">ganig
                                    </tspan>
                                    <tspan class="uuid-20cf6563-804b-4a70-9a16-2ac8b3e648a9" x="154.46" y="0">r</tspan>
                                    <tspan x="172.57" y="0">ama</tspan>
                                    <tspan x="14.19" y="54.04">Corpo</tspan>
                                    <tspan class="uuid-20cf6563-804b-4a70-9a16-2ac8b3e648a9" x="130.28" y="54.04">r
                                    </tspan>
                                    <tspan x="148.38" y="54.04">ati</tspan>
                                    <tspan class="uuid-b28c956f-bcd1-4f02-8297-22ae4ce4d79b" x="198.05" y="54.04">v
                                    </tspan>
                                    <tspan x="219.9" y="54.04">o</tspan>
                                </text>
                                <polyline class="uuid-fbc34c8f-b24a-4b58-b3fa-8458a5000695"
                                    points="173.98 358.66 193.63 379.62 210.83 358.66" />
                                <g>
                                    <path class="uuid-105b6714-0841-41f5-8823-d09004c95d0f"
                                        d="m158.33,320.83h-89.8c-14.64,0-26.55-11.91-26.55-26.55v-5.14c0-14.64,11.91-26.55,26.55-26.55h89.8c14.64,0,26.55,11.91,26.55,26.55v5.14c0,14.64-11.91,26.55-26.55,26.55Zm-89.8-51.94c-11.16,0-20.25,9.08-20.25,20.25v5.14c0,11.16,9.08,20.25,20.25,20.25h89.8c11.16,0,20.25-9.08,20.25-20.25v-5.14c0-11.16-9.08-20.25-20.25-20.25h-89.8Z" />
                                    <path class="uuid-105b6714-0841-41f5-8823-d09004c95d0f"
                                        d="m316.28,320.83h-89.8c-14.64,0-26.55-11.91-26.55-26.55v-5.14c0-14.64,11.91-26.55,26.55-26.55h89.8c14.64,0,26.55,11.91,26.55,26.55v5.14c0,14.64-11.91,26.55-26.55,26.55Zm-89.8-51.94c-11.16,0-20.25,9.08-20.25,20.25v5.14c0,11.16,9.08,20.25,20.25,20.25h89.8c11.16,0,20.25-9.08,20.25-20.25v-5.14c0-11.16-9.08-20.25-20.25-20.25h-89.8Z" />
                                    <path class="uuid-52e1e628-b2fe-444d-98f2-b4fa5b3486f0"
                                        d="m271.38,259.08c-1.74,0-3.15-1.41-3.15-3.15v-14.43H116.58v14.43c0,1.74-1.41,3.15-3.15,3.15s-3.15-1.41-3.15-3.15v-20.74h164.26v20.74c0,1.74-1.41,3.15-3.15,3.15Z" />
                                    <rect class="uuid-52e1e628-b2fe-444d-98f2-b4fa5b3486f0" x="189.42" y="212.19"
                                        width="6.31" height="22.63" />
                                    <path class="uuid-105b6714-0841-41f5-8823-d09004c95d0f"
                                        d="m237.47,215.46h-89.8c-14.64,0-26.55-11.91-26.55-26.55v-5.14c0-14.64,11.91-26.55,26.55-26.55h89.8c14.64,0,26.55,11.91,26.55,26.55v5.14c0,14.64-11.91,26.55-26.55,26.55Zm-89.8-51.94c-11.16,0-20.25,9.08-20.25,20.25v5.14c0,11.16,9.08,20.25,20.25,20.25h89.8c11.16,0,20.25-9.08,20.25-20.25v-5.14c0-11.16-9.08-20.25-20.25-20.25h-89.8Z" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </CardBordes>
        </div>
    </div>
    <div class="row my-1 justify-content-center">
        <!-- Card 2.1 -->
        <div class="col-md-6 col-sm-6 col-lg-3 m-3 d-flex justify-content-center">
            <CardBordes @click="openModalEstadosFinancieros" id="card-estadosFinancieros" minHeight="276px"
                maxHeight="276px" minWidth="261px" maxWidth="261px" borderRadius="30px 0px 30px 0px">
                <template #contenido>
                    <svg id="uuid-910c6d05-79a3-439a-af37-9570c0c2a67d" data-name="Capa 2"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.81 407.93">
                        <g id="uuid-be3d64b6-d9b1-4b57-a432-7b26d72fc584" data-name="Capa 1">
                            <g>
                                <path class="uuid-bf0c1c78-b592-4a41-992b-c9689c3cbb36"
                                    d="m90.25,0h294.56v317.67c0,49.81-40.44,90.25-90.25,90.25H0V90.25C0,40.44,40.44,0,90.25,0Z" />
                                <text class="uuid-90603203-e2c2-484c-9dac-ece2ed120511" transform="translate(108.46 55.83)">
                                    <tspan x="0" y="0">Estados </tspan>
                                    <tspan x="-31.48" y="48.09">Financie</tspan>
                                    <tspan class="uuid-af1a7059-57c5-46ee-98ff-5b1d8399c7be" x="134.83" y="48.09">r
                                    </tspan>
                                    <tspan x="152.93" y="48.09">os</tspan>
                                    <tspan x="-47.82" y="96.17">Consolidados</tspan>
                                </text>
                                <polyline class="uuid-dc964b81-da77-4462-9a86-21a3162e92db"
                                    points="173.98 358.66 193.63 379.62 210.83 358.66" />
                                <g>
                                    <path class="uuid-b82aded0-f015-4443-96f3-d19ff68c670c"
                                        d="m276.49,271.93c-.04-4.16-2.42-7.46-6.37-8.82-2.07-.71-4.15-1.37-6.24-1.99-1.44-.43-2.31-1.31-2.78-2.74-2.02-6.24-5.37-11.69-9.76-16.56-.44-.49-.67-1.47-.55-2.14,1.04-5.85,1.63-11.71.73-17.63-.83-5.5-3.24-7.3-8.64-6.6-.54.07-1.08.15-1.62.26-6.9,1.45-13.4,4.11-19.65,7.22-2.66,1.34-4.66.17-7.06-.18,0-.02.02-.04.02-.07-.04.02-.09.03-.15.03-.03,0-.05-.01-.08-.02-.77,1.69-1.69,3.29-2.73,4.81.03,0,.07-.01.1-.01.12,0,.23,0,.35,0,.17-.08.34-.13.48-.1,1.32.24,2.62.59,3.72.85-.19,3.18-.56,6.12-.52,9.05.18,11.17,8.33,19.1,19.52,19.16,6.07.03,10.58-2.39,12.87-8.25.2-.49.43-.96.65-1.43.21.07.34.08.4.15.29.33.57.66.85,1.01,2.85,3.66,5.04,7.67,6.45,12.1.94,2.94,2.85,4.83,5.81,5.72,1.99.6,3.97,1.24,5.93,1.91,2.37.8,3.34,2.14,3.35,4.64.02,3.4.02,6.79,0,10.18,0,3.07-.92,4.31-3.89,5.27-3.23,1.03-6.46,2.06-9.69,3.08-1.95.61-3.59,1.65-4.63,3.44-4.79,8.18-11.73,14.05-20.01,18.44-1.47.77-2.31,1.87-2.61,3.53-1.04,5.76-2.18,11.49-3.22,17.25-.24,1.34-.74,2.01-2.24,1.95-3.23-.1-6.46-.09-9.69,0-1.47.04-2.02-.56-2.23-1.95-.47-2.97-1.07-5.92-1.65-8.87-.5-2.58-2.18-3.95-4.62-3.59-8.55,1.24-17.11,1.4-25.71.58-3.15-.3-4.49.85-5.07,4-.5,2.69-1.05,5.37-1.5,8.06-.21,1.24-.72,1.79-2.05,1.76-3.34-.07-6.68-.05-10.02,0-1.21.02-1.75-.44-1.97-1.65-.91-5.01-2.03-9.97-2.83-14.99-.42-2.67-1.6-4.39-3.99-5.71-7.41-4.08-13.38-9.75-17.19-17.36-6.5-13-6.76-26.44-1.95-39.97,3.3-9.29,9.75-16.08,18.13-21.13,1.71-1.03,2.17-2.32,1.4-3.65-.76-1.31-2.23-1.55-3.85-.57-12.61,7.56-20.3,18.5-22.85,33.02-.08.48-.28.94-.41,1.4-.46-.46-.53-.85-.57-1.24-.41-3.53-1.82-6.53-4.75-8.66-3.76-2.73-8.06-1.79-10.54,2.25-2.28,3.73-1.18,7.35,3.03,9.52,1.39.72,2.94,1.14,4.43,1.68.45.17.92.27,1.4.41-1.82,3.03-5.02,5.07-8.82,5.41-1.39.13-2.36.66-3.11,1.75v1.65c.73,1.34,1.85,1.95,3.39,1.77.86-.11,1.75-.15,2.59-.37,4.8-1.19,8.14-4.3,10.72-8.35.5-.78.9-1.36,1.48-.95.37,4.74.4,9.2,1.11,13.55,2.48,15.31,10.84,26.58,24.17,34.32.56.33,1.09,1.08,1.22,1.71,1.05,5.09,2.02,10.2,2.98,15.3.75,3.92,2.91,5.72,6.95,5.73,3.34,0,6.68.02,10.02,0,3.8-.02,5.98-1.86,6.69-5.63.5-2.69,1.02-5.36,1.47-7.7,4.44,0,8.69.1,12.95-.02,4.3-.13,8.59-.48,12.98-.73.59,2.99,1.12,6,1.76,8.98.7,3.28,2.92,5.07,6.28,5.1,3.56.03,7.12.02,10.68,0,3.55-.02,5.77-1.84,6.44-5.3,1.07-5.47,2.13-10.95,3.11-16.44.19-1.09.66-1.69,1.61-2.22,8.39-4.64,15.4-10.76,20.41-19.04.48-.8,1.47-1.49,2.37-1.81,3.44-1.23,6.97-2.24,10.43-3.42,3.98-1.35,6.35-4.66,6.39-8.81.04-3.77.03-7.55,0-11.33Zm-32.04-27.78c-2.11,6.2-4.22,8.52-12.72,6.93-6.46-1.21-10.55-6-10.98-12.59-.18-2.85.22-5.77.6-8.63.11-.82.9-1.87,1.65-2.22,6.59-3.05,13.24-6.01,20.43-7.38,2.35-.44,2.8-.16,3.16,2.22.3,1.94.4,3.91.58,5.86-.22,5.4-.98,10.69-2.72,15.8Zm-128.14,18.03c-.92-.4-1.53-1.12-.86-2.21.63-1.05,1.31-2.16,2.81-1.5,2.28,1.01,3.09,3.01,3.62,5.85-2.15-.82-3.89-1.41-5.56-2.14Z" />
                                    <path class="uuid-5f0897df-a5d2-4558-a19f-7232d687442d"
                                        d="m217.32,209.71h0c-.19,7.28-2.69,13.98-6.81,19.38-.03.03-.05.06-.08.09-.49.6-.98,1.21-1.47,1.79-.02.02-.04.05-.05.06-.54.64-1.1,1.27-1.69,1.86-1.53,1.53-3.31,2.81-5.11,4.3,1.3.41,2.53.78,3.76,1.2,1.73.6,2.42,1.74,1.97,3.21-.42,1.39-1.76,1.99-3.49,1.43-3.31-1.07-6.65-1.87-10.04-2.4-3.28-.53-6.61-.79-9.98-.81-3.63-.02-7.21.27-10.75.84-2.96.48-5.9,1.17-8.8,2.08-.53.16-1.05.33-1.58.44-1.39.3-2.37-.25-2.89-1.53-.49-1.21.13-2.56,1.46-3.07,1.37-.52,2.79-.89,4.37-1.39t0,0c-9.41-5.92-15.67-16.39-15.67-28.33,0-17.72,13.8-32.22,31.23-33.35.31-.02.6-.04.91-.05h.06c.41-.02.82-.03,1.23-.03h.31c.28,0,.54,0,.82.02.2,0,.4,0,.59.02.43.02.87.05,1.3.09.63.05,1.24.13,1.85.21.48.08.97.15,1.45.24h0c.37.08.74.15,1.11.24.37.08.73.17,1.09.27.02,0,.02,0,.04.02.27.07.54.15.82.22.27.08.54.16.81.25.22.07.43.14.66.21.31.11.63.22.94.34.39.14.77.3,1.15.46.36.15.72.31,1.07.47,6.45,2.92,11.98,7.88,15.49,14.34.28.53.49,1.01.6,1.45.34,1.29-.04,2.23-1.14,2.82-1.4.75-2.6.12-3.75-1.85-5.84-9.99-14.55-15.05-26.12-14.85-13.13.22-24.59,10.25-26.98,23.35-2.4,13.19,4.9,26.59,17.17,31.42.77.31,1.72.37,2.55.26,5.57-.66,11.13-.65,16.71,0,.97.11,2.11-.04,2.99-.45,10.24-4.76,15.96-12.77,17.05-24.03.14-1.38.38-2.66,1.98-3.01,1.4-.32,2.56.43,2.86,1.79Z" />
                                    <path class="uuid-5f0897df-a5d2-4558-a19f-7232d687442d"
                                        d="m186.92,224.58c-.6.65-1.2,1.3-1.8,1.95-.55-.59-1.1-1.17-1.65-1.76.11-.14.23-.28.34-.42-1.11-.21-2.3-.23-3.31-.66-1.58-.67-3.1-1.53-4.51-2.51-.54-.37-1.01-1.33-.94-1.96.1-.82.62-1.76,1.26-2.26.35-.27,1.47.09,1.99.49,1.62,1.25,3.24,2.41,5.58,2.51,0-3.19.03-6.34-.04-9.49,0-.32-.54-.72-.92-.91-.97-.49-2.02-.83-2.98-1.34-3.07-1.61-4.52-4.22-4.22-7.5.32-3.42,2.17-5.63,5.4-6.7.82-.27,1.68-.44,2.26-.92.63-.64,1.25-1.27,1.88-1.91.53.56,1.05,1.12,1.89,2.02,1.22.32,3.02.71,4.75,1.29,1.2.41,1.85,1.33,1.47,2.71-.39,1.42-1.36,1.88-2.76,1.36-1.29-.49-2.6-.93-4.15-1.48,0,3.02-.02,5.64.03,8.25,0,.33.37.7.66.95.23.2.6.26.9.39,4.62,2,6.6,4.96,6.24,9.31-.36,4.47-2.61,6.86-7.63,8.11.08.15.17.31.25.46Zm-.66-13.6v8.73c2.1-.14,3.33-1.25,3.67-3.27.41-2.43-.76-4.24-3.67-5.46Zm-2.17-6v-7.46c-2.59.29-3.94,1.42-4.05,3.33-.11,2.06,1.46,3.67,4.05,4.13Z" />
                                    <path class="uuid-b82aded0-f015-4443-96f3-d19ff68c670c"
                                        d="m241.53,273.09c-4.14,0-7.52-3.08-7.97-7.23-.18-1.64.61-2.87,1.99-3.1,1.54-.25,2.58.61,2.87,2.38.32,1.93,1.41,3.02,3.05,3.05,1.71.04,2.85-1.06,3.17-3.08.27-1.67,1.27-2.54,2.75-2.38,1.42.15,2.24,1.3,2.14,2.97-.26,4.12-3.8,7.38-8,7.38Z" />
                                    <path class="uuid-b82aded0-f015-4443-96f3-d19ff68c670c"
                                        d="m210.44,229.18c-.47.62-.96,1.21-1.47,1.79.5-.59.98-1.19,1.47-1.79Z" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </CardBordes>
        </div>
        <!-- Card 2.2 -->

        <div @click="openModalEmpresasSociales" class="col-md-6 col-sm-6 col-lg-3 m-3 d-flex justify-content-center">
            <CardBordes id="card-empresasSociales" minHeight="276px" maxHeight="276px" minWidth="261px" maxWidth="261px"
                borderRadius="30px 0px 30px 0px">

                <template #contenido>
                    <svg id="uuid-d83afe1b-c482-4891-b905-2b9496be65da" data-name="Capa 2"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.81 407.93">
                        <g id="uuid-9e9473cc-5f3e-4c85-ace5-e6d9bce74f2f" data-name="Capa 1">
                            <g>
                                <path class="uuid-f4afe87d-6934-4bb1-9b2f-5622979a76f0"
                                    d="m90.25,0h294.56v317.67c0,49.81-40.44,90.25-90.25,90.25H0V90.25C0,40.44,40.44,0,90.25,0Z" />
                                <text class="uuid-a4bbbc48-01c3-4327-996f-9b749020f892" transform="translate(107.02 72.08)">
                                    <tspan x="0" y="0">Nuest</tspan>
                                    <tspan class="uuid-e3b0de1a-37c9-4e81-9612-8c8d38d1f96a" x="114.47" y="0">r</tspan>
                                    <tspan class="uuid-32cbca73-b069-4022-a624-019c9e596710" x="132.58" y="0">as</tspan>
                                    <tspan x="-94.86" y="54.04">emp</tspan>
                                    <tspan class="uuid-e3b0de1a-37c9-4e81-9612-8c8d38d1f96a" x="-8.89" y="54.04">r
                                    </tspan>
                                    <tspan x="9.21" y="54.04">esas sociales</tspan>
                                </text>
                                <polyline class="uuid-b423dafd-3f17-4893-a2c5-a84087652142"
                                    points="173.98 358.66 193.63 379.62 210.83 358.66" />
                                <g>
                                    <path class="uuid-aedab406-19e8-451a-b1d3-fc0e7e4a2660"
                                        d="m106.23,326.1v-117.97c1.86-5.68,5.91-7.65,11.7-7.52,9.8.22,19.6.06,29.4.06h2.26c0-1,0-1.71,0-2.43,0-6.23.01-12.46,0-18.69,0-3.37,1.11-6.35,4.04-8.03,1.93-1.1,2.44-2.38,2.19-4.32-.04-.3,0-.6.02-.91.3-5.19,4.13-8.95,9.32-8.96,16.52-.04,33.04-.03,49.55,0,4.43,0,8.12,3,8.99,7.27.3,1.46.09,3.02.26,4.51.06.54.43,1.26.88,1.5,3.67,1.99,5.34,5.04,5.29,9.19-.06,6.23-.02,12.46-.02,18.69,0,.65,0,1.3,0,2.17.93,0,1.64,0,2.35,0,9.92,0,19.85.22,29.77-.07,7.84-.22,11.46,4.78,11.39,11.3-.21,21.29-.08,42.59-.08,63.88v2.34c3.31-2.05,5.75-4.34,7.8-7.07,1.26-1.67,2.91-2.56,5.04-2.1,2.28.49,3.58,2.02,3.87,4.27.65,5.03,1.51,10.06,1.71,15.12.43,10.85-1.27,21.37-6.47,31.05-5.73,10.67-14.11,18.48-25.72,22.46-1.75.6-3.61.89-5.42,1.32h-7.26c-.39-.12-.77-.29-1.17-.36-5.29-.9-10.05-3-14.18-6.44-1.94-1.62-3.79-3.33-5.72-5.03.03-.04-.25.33-.52.71-3.63,5.12-8.48,8.53-14.52,10.23-1.15.32-2.31.6-3.46.9h-6.9c-.15-.09-.3-.24-.46-.26-7.87-1.13-13.97-5.42-19.4-10.88-.89-.89-1.73-1.26-2.98-1.26-21.17.04-42.33-.03-63.5.08-3.81.02-6.57-1.13-8.06-4.74Zm117.7-25.89c0-1.05,0-1.64,0-2.23,0-39.19,0-78.39,0-117.58,0-3.7-.85-4.53-4.63-4.53-19.6,0-39.2,0-58.8,0-3.86,0-4.68.82-4.68,4.68,0,47.24,0,94.48,0,141.72,0,.71,0,1.42,0,2.2h19.03c-.88-1.83-1.78-3.48-2.48-5.2-4.92-12.07-4.99-24.49-2.5-37.07.37-1.87,1.63-3.1,3.51-3.53,1.9-.44,3.5.2,4.65,1.73,5.39,7.21,12.95,9.98,21.54,10,9.33.03,17.49,2.55,24.37,9.8Zm-111.51,24.3h37.02v-117.63c-.75,0-1.35,0-1.95,0-10.22,0-20.44,0-30.66,0-3.5,0-4.41.91-4.41,4.39,0,37.07,0,74.13,0,111.2v2.03Zm121.02,5.11c6.42,6.17,14.04,8.77,22.83,6.75,8.78-2.02,15.26-7.63,20.55-14.63,6.35-8.41,8.74-18.19,9.11-28.54.19-5.36-.21-10.68-1.54-16.18-.54.35-.81.89-1.19,1.35-.38.47-.85.86-1.3,1.26-7.85,7-17.29,9.3-27.5,9.28-4.48-.01-8.77.82-12.85,2.65-11.99,5.37-17.58,18.62-12.85,30.48.34.86.51,1.83,1.97,1.48,6.54-1.59,12.88-3.67,18.83-6.87,7.8-4.2,13.88-10.2,18.75-17.53,1.21-1.82,2.99-2.19,4.52-1.15,1.49,1.02,1.72,2.87.56,4.64-6.17,9.45-14.26,16.74-24.61,21.28-4.9,2.15-10.02,3.78-15.27,5.73Zm-3.17-122.74v84.57c.37-.25.58-.37.76-.52,5.87-4.98,12.71-7.51,20.34-8.13,4.68-.38,9.36-.89,14.04-1.35,1.51-.15,2-.89,2-2.49-.06-22.55-.04-45.11-.04-67.66,0-3.47-.93-4.41-4.41-4.41-10.28,0-20.56,0-30.85,0-.59,0-1.18,0-1.84,0Zm-12.12,124.18c-.88-.26-1.55-.46-2.23-.65-12.97-3.6-23.75-10.33-31.25-21.78-1.25-1.91-1.13-3.73.39-4.8,1.57-1.11,3.27-.66,4.66,1.19,1.3,1.74,2.55,3.54,3.97,5.18,7.01,8.12,16.2,12.39,26.41,14.83.69.17,1.9.3,2.09-.02.36-.6.39-1.62.16-2.34-1.27-3.92-1.96-7.98-1.23-11.98.6-3.27-.72-5.39-2.8-7.31-1.53-1.42-3.25-2.73-5.07-3.76-4.32-2.45-9.08-2.94-14-3.03-8.86-.16-16.9-2.72-23.36-9.15-.14-.14-.36-.19-.64-.33-1.01,6.21-1.21,12.29-.37,18.38,1.77,12.83,7.89,22.83,19.44,29.11,7.76,4.22,18,2.69,23.82-3.55Zm-.57-161.47c.6-4.54-.16-6.19-5.16-6.15-14.93.14-29.85.05-44.78.05-.85,0-1.7-.04-2.54.02-1.81.12-2.91,1.18-3.04,2.97-.07,1-.01,2.01-.01,3.11h55.53Z" />
                                    <path class="uuid-b1a00840-d9d6-45e1-bf9e-b3cfcc277851"
                                        d="m162.03,194.44c0-2.05-.05-4.11,0-6.16.11-3.55,2.5-6.08,6.04-6.18,4.23-.12,8.46-.13,12.69,0,3.5.11,5.95,2.72,6.01,6.24.07,4.11.08,8.22,0,12.32-.07,3.45-2.44,6.01-5.9,6.13-4.34.15-8.7.16-13.05,0-3.41-.13-5.66-2.61-5.78-6.02-.07-2.11-.01-4.23-.02-6.34Zm6.28,6.11h12.18v-12.16h-12.18v12.16Z" />
                                    <path class="uuid-b1a00840-d9d6-45e1-bf9e-b3cfcc277851"
                                        d="m217.73,194.56c0,1.99.03,3.99,0,5.98-.06,3.51-2.29,6.11-5.74,6.25-4.4.18-8.82.18-13.23,0-3.44-.14-5.72-2.76-5.76-6.24-.04-4.05-.04-8.1,0-12.14.04-3.6,2.5-6.22,6.11-6.32,4.17-.11,8.34-.11,12.51,0,3.61.1,6.04,2.7,6.11,6.31.04,2.05,0,4.11,0,6.16Zm-18.47-6.22v12.21h12.15v-12.21h-12.15Z" />
                                    <path class="uuid-b1a00840-d9d6-45e1-bf9e-b3cfcc277851"
                                        d="m217.73,225.55c0,1.99.03,3.99,0,5.98-.07,3.61-2.54,6.24-6.1,6.31-4.17.09-8.34.09-12.51,0-3.57-.08-6.08-2.72-6.12-6.31-.04-4.05-.04-8.1,0-12.14.04-3.63,2.49-6.19,6.11-6.27,4.17-.09,8.34-.09,12.51,0,3.63.07,6.04,2.61,6.11,6.27.04,2.05,0,4.11,0,6.16Zm-18.46-6.17v12.19h12.15v-12.19h-12.15Z" />
                                    <path class="uuid-aedab406-19e8-451a-b1d3-fc0e7e4a2660"
                                        d="m205.27,268.79c-2.05,0-4.11.04-6.16-.01-3.49-.09-6.06-2.62-6.1-6.1-.06-4.17-.06-8.34,0-12.51.05-3.47,2.64-6.05,6.11-6.1,4.17-.06,8.34-.06,12.51,0,3.48.05,6.04,2.62,6.09,6.11.06,4.17.06,8.34,0,12.51-.05,3.5-2.59,6.01-6.1,6.1-2.11.05-4.23,0-6.34,0Zm6.2-18.41h-12.21v12.12h12.21v-12.12Z" />
                                    <path class="uuid-aedab406-19e8-451a-b1d3-fc0e7e4a2660"
                                        d="m174.39,268.79c-2.11,0-4.23.05-6.34-.01-3.34-.09-5.89-2.49-5.97-5.82-.11-4.35-.11-8.7,0-13.05.09-3.32,2.65-5.78,5.97-5.83,4.23-.07,8.46-.07,12.69,0,3.35.05,5.95,2.61,6.03,6.01.1,4.23.11,8.46,0,12.69-.09,3.48-2.71,5.94-6.21,6.01-2.05.04-4.11,0-6.16,0Zm-6.09-6.28h12.19v-12.15h-12.19v12.15Z" />
                                    <path class="uuid-aedab406-19e8-451a-b1d3-fc0e7e4a2660"
                                        d="m162.02,225.35c0-1.99-.04-3.99,0-5.98.1-3.7,2.47-6.17,6.13-6.24,4.17-.08,8.34-.08,12.51,0,3.52.07,6.04,2.59,6.11,6.11.08,4.17.09,8.34,0,12.5-.08,3.47-2.67,6.04-6.15,6.11-4.17.08-8.34.09-12.51,0-3.51-.08-5.95-2.61-6.07-6.15-.07-2.11-.01-4.23-.01-6.34,0,0,0,0,0,0Zm18.48,6.25v-12.19h-12.15v12.19h12.15Z" />
                                    <path class="uuid-b1a00840-d9d6-45e1-bf9e-b3cfcc277851"
                                        d="m143.37,287.52c0,2.05.06,4.11-.01,6.16-.12,3.42-2.35,5.91-5.76,6.04-4.4.17-8.82.17-13.23,0-3.35-.13-5.68-2.71-5.74-6.08-.08-4.11-.07-8.22,0-12.32.05-3.59,2.56-6.19,6.16-6.28,4.17-.11,8.34-.11,12.51,0,3.55.1,5.95,2.61,6.07,6.15.07,2.11.01,4.23.01,6.34Zm-6.27-6.23h-12.19v12.16h12.19v-12.16Z" />
                                    <path class="uuid-b1a00840-d9d6-45e1-bf9e-b3cfcc277851"
                                        d="m130.96,268.79c-2.05,0-4.11.04-6.16-.01-3.49-.08-6.09-2.57-6.17-6.05-.09-4.17-.09-8.34,0-12.5.07-3.58,2.69-6.12,6.27-6.16,4.05-.04,8.1-.04,12.15,0,3.72.03,6.25,2.5,6.32,6.25.07,4.11.08,8.22,0,12.32-.07,3.65-2.59,6.08-6.23,6.15-2.05.04-4.11,0-6.16,0Zm-6.03-18.47v12.19h12.14v-12.19h-12.14Z" />
                                    <path class="uuid-aedab406-19e8-451a-b1d3-fc0e7e4a2660"
                                        d="m130.98,213.1c2.11,0,4.23-.06,6.34.02,3.48.13,5.93,2.51,6.01,5.97.1,4.23.1,8.46,0,12.69-.08,3.51-2.62,6-6.15,6.07-4.11.08-8.22.07-12.33,0-3.58-.06-6.18-2.64-6.25-6.2-.08-4.11-.07-8.22,0-12.32.06-3.61,2.57-6.09,6.2-6.21,2.05-.06,4.11-.01,6.16,0Zm6.08,18.48v-12.17h-12.13v12.17h12.13Z" />
                                    <path class="uuid-aedab406-19e8-451a-b1d3-fc0e7e4a2660"
                                        d="m248.75,237.87c-1.99,0-3.99.03-5.98,0-3.72-.08-6.3-2.5-6.41-6.22-.12-4.11-.11-8.22,0-12.32.1-3.76,2.61-6.15,6.39-6.2,3.99-.06,7.98-.06,11.96,0,3.85.06,6.35,2.51,6.43,6.36.08,3.99.08,7.98,0,11.96-.08,3.9-2.67,6.38-6.59,6.43-1.93.03-3.87,0-5.8,0Zm6.11-18.49h-12.21v12.18h12.21v-12.18Z" />
                                    <path class="uuid-b1a00840-d9d6-45e1-bf9e-b3cfcc277851"
                                        d="m248.71,268.79c-1.99,0-3.99.03-5.98,0-3.59-.06-6.2-2.32-6.33-5.87-.17-4.34-.17-8.7.01-13.04.14-3.46,2.75-5.77,6.2-5.81,4.05-.05,8.1-.04,12.15,0,3.63.03,6.24,2.42,6.36,6.05.14,4.22.15,8.46,0,12.68-.13,3.63-2.74,5.93-6.42,5.99-1.99.03-3.99,0-5.98,0Zm6.1-6.26v-12.21h-12.17v12.21h12.17Z" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>

            </CardBordes>
        </div>

        <!-- Card 2.3 -->
        <div class="col-md-6 col-sm-6 col-lg-3 m-3 d-flex justify-content-center">
            <CardBordes @click="openModalHogarDeCristoPrensaRRSS" id="card-prensaRsss" minHeight="276px" maxHeight="276px"
                minWidth="261px" maxWidth="261px" borderRadius="30px 0px 30px 0px">
                <template #contenido>
                    <svg id="uuid-3fc0f8ec-44ba-465a-bc2c-7c32fadcaff4" data-name="Capa 2"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.81 407.93">
                        <g id="uuid-da150a46-ee0d-4909-88c4-91f8486be0cc" data-name="Capa 1">
                            <g>
                                <path class="uuid-be203a02-023d-404d-86a6-2763f79933c6"
                                    d="m90.25,0h294.56v317.67c0,49.81-40.44,90.25-90.25,90.25H0V90.25C0,40.44,40.44,0,90.25,0Z" />
                                <text class="uuid-d6a26b26-1e31-494a-b04f-43ad1c9c7a43" transform="translate(33.66 71.21)">
                                    <tspan x="0" y="0">Hogar de Cristo </tspan>
                                    <tspan x="-17.37" y="55.87">en P</tspan>
                                    <tspan class="uuid-2d13bd57-7b58-4864-ac4f-5b215300cfed" x="71.38" y="55.87">r
                                    </tspan>
                                    <tspan x="90.09" y="55.87">ensa y RRSS</tspan>
                                </text>
                                <polyline class="uuid-f5a27c19-dfb1-494a-8638-1fb0b55c81bd"
                                    points="173.98 358.66 193.63 379.62 210.83 358.66" />
                                <g>
                                    <path class="uuid-07a3998a-7cc5-4824-b1e4-5dcfd00ba8c7"
                                        d="m105.69,319.32c0-38.38,0-76.76,0-115.14.99-1.83,2.51-2.58,4.6-2.39,1.34.12,2.7.02,4.05.02,2.06,0,4.12,0,6.25,0,0-5.88,0-11.5,0-17.13,0-3.48,1.06-4.54,4.54-4.54,3.42,0,6.83,0,10.36,0,0-4.7.08-9.2-.04-13.69-.06-2.08.57-3.6,2.41-4.59h138.85c1.84,1,2.41,2.52,2.4,4.6-.04,49.83-.03,99.66-.06,149.48,0,1.73-.12,3.52-.52,5.2-2.04,8.6-9.29,14.1-18.47,14.11-35.1,0-70.2,0-105.3,0-10.21,0-20.43.03-30.64-.01-8.18-.04-15.05-5.04-17.54-12.69-.35-1.06-.6-2.15-.9-3.22Zm21.67-132.34v2.3c0,40.97,0,81.95,0,122.92,0,3.1-1.13,4.7-3.34,4.73-2.26.03-3.44-1.6-3.44-4.8,0-33.81,0-67.61,0-101.42v-2.03h-8.13v1.94c0,35.05,0,70.09,0,105.14,0,.62-.01,1.24.02,1.86.31,5.82,5.2,10.62,11.02,10.83,6.65.23,11.96-4.93,11.98-11.74.03-14.67.01-29.35.01-44.02,0-.56-.03-1.13.02-1.69.18-1.82,1.62-3.15,3.38-3.14,1.75,0,3.18,1.34,3.35,3.18.05.5.02,1.02.02,1.52,0,14.39-.04,28.78.02,43.17.02,4.43-.99,8.48-3.61,12.09-.11.15-.12.36-.2.65h1.82c39.79,0,79.57,0,119.36,0,7.92,0,12.65-4.72,12.65-12.61,0-48.42,0-96.84,0-145.27v-1.87h-130.05v2.1c0,22.86,0,45.71,0,68.57,0,.62.04,1.25-.06,1.86-.25,1.65-1.65,2.85-3.27,2.88-1.69.03-3.16-1.22-3.4-2.93-.08-.61-.05-1.24-.05-1.86,0-16.76,0-33.52,0-50.28v-2.06h-8.13Z" />
                                    <path class="uuid-0f00994f-603b-4d4b-aea7-f962d7bb0b32"
                                        d="m207.3,215.36c-16.98,0-33.96,0-50.94,0-3.57,0-4.61-1.05-4.61-4.65,0-7.39,0-14.78,0-22.17,0-3.16,1.15-4.33,4.25-4.33,34.19,0,68.37,0,102.56,0,3.11,0,4.27,1.18,4.27,4.31,0,7.5,0,15.01,0,22.51,0,3.2-1.16,4.33-4.42,4.33-17.04,0-34.07,0-51.11,0Zm48.68-24.26h-97.38v17.4h97.38v-17.4Z" />
                                    <path class="uuid-0f00994f-603b-4d4b-aea7-f962d7bb0b32"
                                        d="m151.75,260.75c0-10.49,0-20.98,0-31.48,0-3.34,1.11-4.43,4.48-4.44,16.64,0,33.28,0,49.92,0,3.45,0,4.52,1.08,4.52,4.57,0,20.87,0,41.74,0,62.61,0,3.57-1.05,4.61-4.66,4.61-16.58,0-33.17,0-49.75,0-3.45,0-4.52-1.08-4.52-4.58,0-10.44,0-20.87,0-31.31Zm52.03,29.04v-58.04h-45.17v58.04h45.17Z" />
                                    <path class="uuid-0f00994f-603b-4d4b-aea7-f962d7bb0b32"
                                        d="m207.27,312.89c-16.92,0-33.84,0-50.76,0-.62,0-1.25.04-1.86-.05-1.71-.26-2.94-1.75-2.88-3.44.05-1.62,1.27-3,2.92-3.23.55-.08,1.13-.05,1.69-.05,33.96,0,67.91,0,101.87,0,.51,0,1.02-.03,1.52.03,1.73.2,3.02,1.61,3.05,3.29.03,1.75-1.28,3.23-3.09,3.42-.56.06-1.13.03-1.69.03-16.92,0-33.84,0-50.76,0Z" />
                                    <path class="uuid-0f00994f-603b-4d4b-aea7-f962d7bb0b32"
                                        d="m241.47,224.84c5.75,0,11.5,0,17.24,0,2.56,0,4.14,1.35,4.1,3.45-.04,2.04-1.58,3.32-4.06,3.32-11.5,0-22.99,0-34.49,0-2.56,0-4.14-1.35-4.1-3.45.04-2.04,1.57-3.31,4.06-3.31,5.75-.01,11.5,0,17.24,0Z" />
                                    <path class="uuid-0f00994f-603b-4d4b-aea7-f962d7bb0b32"
                                        d="m241.64,241.09c5.69,0,11.38,0,17.07,0,2.56,0,4.14,1.35,4.1,3.45-.04,2.04-1.58,3.32-4.06,3.32-11.5,0-22.99,0-34.49,0-2.56,0-4.14-1.35-4.1-3.45.04-2.04,1.57-3.31,4.06-3.31,5.8-.01,11.61,0,17.41,0Z" />
                                    <path class="uuid-0f00994f-603b-4d4b-aea7-f962d7bb0b32"
                                        d="m241.32,264.12c-5.69,0-11.38,0-17.07,0-2.55,0-4.13-1.37-4.08-3.47.05-2.03,1.59-3.3,4.08-3.3,11.5,0,22.99,0,34.49,0,2.49,0,4.03,1.27,4.08,3.3.05,2.1-1.54,3.46-4.08,3.47-5.8.01-11.61,0-17.41,0Z" />
                                    <path class="uuid-0f00994f-603b-4d4b-aea7-f962d7bb0b32"
                                        d="m241.48,273.61c5.75,0,11.5,0,17.24,0,2.55,0,4.14,1.36,4.09,3.45-.04,2.04-1.59,3.31-4.07,3.31-11.5,0-22.99,0-34.49,0-2.56,0-4.14-1.35-4.09-3.46.04-2.04,1.58-3.31,4.07-3.31,5.75,0,11.5,0,17.24,0Z" />
                                    <path class="uuid-0f00994f-603b-4d4b-aea7-f962d7bb0b32"
                                        d="m241.5,296.63c-5.75,0-11.5,0-17.24,0-2.55,0-4.13-1.36-4.08-3.46.05-2.04,1.58-3.3,4.07-3.3,11.5,0,22.99,0,34.49,0,2.55,0,4.14,1.37,4.09,3.46-.05,2.03-1.59,3.3-4.07,3.31-5.75,0-11.5,0-17.24,0Z" />
                                    <path class="uuid-07a3998a-7cc5-4824-b1e4-5dcfd00ba8c7"
                                        d="m139.01,259.37c-1.83-.02-3.3-1.52-3.3-3.38,0-1.85,1.47-3.35,3.3-3.38,1.9-.03,3.43,1.54,3.38,3.46-.04,1.85-1.55,3.32-3.38,3.29Z" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </CardBordes>
        </div>
    </div>

    <div class="row my-1 justify-content-center">
        <div class="d-flex justify-content-center align-items-center">
            <!-- Card 3.1 -->
            <CardBordes @click="openModalContactanos" id="card-formulario" minHeight="200px" maxHeight="200px"
                minWidth="300px" style=" background-color: rgba(0, 0, 0, 0);" maxWidth="600px"
                borderRadius="30px 0px 30px 0px">
                <template #contenido>
                    <svg id="uuid-b06ac483-e950-438a-80bc-c9283415a635" data-name="Capa 2"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 573.88 125.2">
                        <g id="uuid-54f96a9a-3db1-4582-80e9-b16861ff4cf7" data-name="Capa 1">
                            <g>
                                <path class="uuid-f1954807-b076-406d-8c48-414df648757c"
                                    d="m47.58,0h526.3v77.62c0,26.26-21.32,47.58-47.58,47.58H0V47.58C0,21.32,21.32,0,47.58,0Z" />
                                <text class="uuid-d357ddef-3ed2-4d66-af7b-7d1d908c3e61" transform="translate(55.63 74.78)">
                                    <tspan class="uuid-702cc2e3-9582-4a25-ac67-ce06799f52f9" x="0" y="0">F</tspan>
                                    <tspan x="15.68" y="0">ormulario pa</tspan>
                                    <tspan class="uuid-83365aae-c685-429b-b029-1fa3291fe21d" x="184.46" y="0">r</tspan>
                                    <tspan class="uuid-9e61f343-45a6-4188-88f2-54d21b501b26" x="196.47" y="0">a consu
                                    </tspan>
                                    <tspan class="uuid-438bd32b-9f03-46f2-aaf1-738d518f2313" x="296.53" y="0">l</tspan>
                                    <tspan class="uuid-19d7e5f7-e1c9-4e2c-9afd-3ea672066162" x="305.16" y="0">tas</tspan>
                                </text>
                                <g>
                                    <path class="uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9"
                                        d="m502.43,19.59c.02-.93-.27-1.59-1.11-1.99h-58.8c-.81.48-1.07,1.17-1.07,2.11.02,24.85.01,49.71.01,74.56,0,1.63.49,2.13,2.1,2.13h37.87c-.33-.26-.56-.66-.58-1.11l.05-.5.15-1.5h-36.46V20.74h54.74c0,1.47-.01,2.88,0,4.29.01,1.1.65,1.81,1.57,1.8.92-.02,1.49-.69,1.5-1.77,0-1.82-.03-3.64.02-5.46Zm.11,27.53c-.12-.37-.12-.68-.12-.98,0-2.33.01-4.67-.01-7,0-.87-.61-1.48-1.42-1.53-.82-.05-1.52.55-1.63,1.42-.03.25-.01.51-.01.77,0,4.05.01,8.11-.02,12.16,0,.48-.15,1.02-.39,1.44l3.95-6.82c-.11.19-.23.37-.35.56Zm-3.58,32.13c.09-.14.2-.31.34-.54v14.55h-12l-3.55,2.7c-.09.16-.22.31-.37.42h16.98c1.59,0,2.06-.48,2.06-2.06,0-6.77,0-13.54.02-20.32,0-.48.14-1.02.38-1.43.26-.46.53-.92.8-1.38l-4.66,8.05Z" />
                                    <path class="uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9"
                                        d="m519.53,37.83c-1.1-2.19-2.91-3.43-5.35-3.59-2.54-.16-4.59.87-5.9,3.04-1.67,2.75-3.24,5.55-4.84,8.33-.16.28-.32.57-.49.85-.02.04-.04.08-.07.11l-3.95,6.82-.46.79-.03.05c-5.21,9.07-10.45,18.13-15.68,27.2-.24.41-.47.87-.52,1.34-.3,2.44-.54,4.89-.8,7.34-.12,1.06-.25,2.12-.37,3.18h-.02l-.15,1.5-.05.5c.03.45.25.85.58,1.11.27.22.6.34.97.34s.7-.13.97-.34c.07-.06.14-.12.2-.19.15-.17.3-.33.48-.47l3.24-2.47h-.02c.2-.14.39-.28.58-.42,1.67-1.22,3.26-2.35,4.8-3.54.51-.39.98-.9,1.31-1.46,1.53-2.57,3.02-5.17,4.51-7.77l.45-.77.04-.06,4.66-8.05c4.88-8.49,9.79-16.96,14.66-25.47.78-1.36,1.33-2.85,1.98-4.28v-1.54c-.23-.7-.39-1.44-.71-2.09Zm-35.16,53.73c.23-2.16.45-4.15.68-6.29,1.48.85,2.91,1.67,4.44,2.56-1.72,1.26-3.35,2.44-5.12,3.73Zm7.37-5.99c-1.99-1.15-3.89-2.25-5.87-3.39,7.51-13,14.99-25.97,22.53-39.01,1.96,1.13,3.88,2.23,5.87,3.38-7.51,13.01-14.99,25.97-22.53,39.02Zm25.11-43.57c-.28.62-.65,1.21-1.03,1.89-2-1.15-3.9-2.25-5.88-3.4.42-.69.76-1.37,1.22-1.96,1.02-1.32,2.93-1.62,4.36-.75,1.43.88,2.02,2.68,1.34,4.22Z" />
                                    <path class="uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9"
                                        d="m471.99,33.91c4.97,0,9.94,0,14.91,0,.26,0,.52-.01.77.02.8.1,1.34.74,1.34,1.52,0,.78-.55,1.41-1.35,1.52-.25.03-.51.02-.77.02-9.97,0-19.94,0-29.91,0-.1,0-.21,0-.31,0-1.09-.01-1.82-.63-1.82-1.54,0-.91.73-1.53,1.83-1.53,5.1,0,10.2,0,15.3,0Z" />
                                    <path class="uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9"
                                        d="m471.91,42.53c5,0,9.99,0,14.99,0,.26,0,.52-.01.77.02.8.1,1.35.73,1.35,1.52,0,.79-.55,1.42-1.34,1.52-.25.03-.51.02-.77.02-9.97,0-19.94,0-29.91,0-.05,0-.1,0-.15,0-1.23,0-1.98-.58-1.98-1.54,0-.96.74-1.54,1.98-1.54,5.02,0,10.05,0,15.07,0Z" />
                                    <path class="uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9"
                                        d="m472,62.85c-5.13,0-10.25,0-15.38,0-1.31,0-2.1-1.04-1.64-2.11.28-.66.81-.96,1.52-.96.95,0,1.9,0,2.84,0,9.15,0,18.3,0,27.45,0,.28,0,.57-.02.84.02.8.09,1.36.72,1.36,1.5,0,.79-.53,1.43-1.33,1.54-.25.04-.51.02-.77.02-4.97,0-9.94,0-14.91,0Z" />
                                    <path class="uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9"
                                        d="m463.15,77.01c2.15,0,4.3,0,6.45,0,1.2,0,1.88.57,1.87,1.55,0,.97-.68,1.53-1.89,1.53-4.33,0-8.65,0-12.98,0-.97,0-1.64-.55-1.73-1.39-.08-.74.46-1.48,1.21-1.64.25-.05.51-.04.76-.04,2.1,0,4.2,0,6.3,0Z" />
                                    <path class="uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9"
                                        d="m481.77,54.23c-1.82,0-3.63,0-5.45,0-1.11,0-1.8-.62-1.78-1.56.01-.91.69-1.51,1.76-1.51,3.66,0,7.32,0,10.98,0,1.07,0,1.73.6,1.74,1.52,0,.93-.65,1.54-1.71,1.55-1.84.01-3.69,0-5.53,0Z" />
                                    <path class="uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9"
                                        d="m461.52,54.23c-1.61,0-3.23,0-4.84,0-1.09,0-1.82-.64-1.81-1.55.01-.91.73-1.52,1.84-1.52,3.23,0,6.46,0,9.69,0,1.1,0,1.82.63,1.81,1.55-.01.92-.73,1.52-1.84,1.52-1.61,0-3.23,0-4.84,0Z" />
                                    <path class="uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9"
                                        d="m476.07,71.46c-1.51,0-3.03,0-4.54,0-1.14,0-1.8-.59-1.79-1.55,0-.96.67-1.52,1.82-1.52,3,0,6,0,9,0,1.15,0,1.82.56,1.83,1.51.01.98-.67,1.56-1.86,1.56-1.49,0-2.98,0-4.46,0Z" />
                                    <path class="uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9"
                                        d="m460.29,71.46c-1.23,0-2.46,0-3.68,0-1.03,0-1.74-.64-1.75-1.53,0-.89.71-1.54,1.74-1.54,2.51,0,5.01,0,7.52,0,1.04,0,1.74.63,1.75,1.53,0,.9-.7,1.53-1.74,1.54-1.28.01-2.56,0-3.84,0Z" />
                                    <path class="uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9"
                                        d="m500.9,30.68c.84.01,1.5.69,1.5,1.54,0,.84-.67,1.52-1.5,1.53-.85,0-1.58-.74-1.56-1.58.03-.82.75-1.5,1.56-1.49Z" />
                                    <line class="uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9" x1="503.44" y1="45.61"
                                        x2="502.88" y2="46.57" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </CardBordes>
        </div>
    </div>

    <!-- MODAL FUNERARIA HOGAR DE CRISTO -->
    <CardModalAmarilloCompleto ref="modalFunerariaHogarDeCristo" :muestra-nav="true" background-color="#FFF"
        :otherModalRef="modalEmpresasSociales" overflow-y="scroll" display="flex" flex-direction="column"
        :tituloBlanco="false" :scrollBlanco="false">

        <div class="col">
            <div class="bg-white">
                <div class="row my-1 d-flex justify-content-center align-items-center">
                    <img src="../../assets/image/Sostenibilidad_Transparencia/Funeraria.jpg"
                        class="imagen-adaptativa p-3" alt="Funeraria hogar de cristo"/>
                </div>

                <div class="row text-justify p-4">
                    <p class="font-dinn-regular fs-5">
                        La Funeraria de HDC acompaña a las familias que atraviesan la partida de un ser querido y con el
                        firme
                        compromiso, en línea con su rol social, que todas las personas, aún después de su muerte, sean
                        tratadas
                        con respeto y dignidad.
                    </p>
                </div>
            </div>


            <div class="backgroundAmarillo">

                <div class="row">
                    <div class="col-md-4 col-sm-12  p-4 border-height-line text-center text-white">
                        <div class="row">
                            <h5 class="font-dinn-bold fs-5">
                                <u>
                                    Misión
                                </u>
                            </h5>
                        </div>

                        <div class="row font-dinn-regular text-center px-3 fs-5">
                            Entregar a los clientes un servicio de excelencia, acompañándolos en todo momento.
                        </div>

                    </div>

                    <div class="col-md-4 col-sm-12  p-4 border-height-line text-center text-white">
                        <div class="row">
                            <h5 class="font-dinn-bold fs-5">
                                <u>
                                    Visión
                                </u>
                            </h5>
                        </div>

                        <div class="row">
                            <span class="font-dinn-regular text-center fs-5">
                                Ser la primera preferencia en la elección de un servicio funerario, ya que, además de
                                prestar un
                                servicio de calidad, nuestra acción se basa en valores sociales.
                            </span>
                        </div>

                    </div>

                    <div class="col-md-4 col-sm-12  p-4 border-height-line text-center text-white">
                        <div class="row">
                            <h5 class="font-dinn-bold fs-5">
                                <u>
                                    Valores
                                </u>
                            </h5>
                        </div>

                        <div class="col font-dinn-regular text-center fs-5">
                            Empatía<br>
                            Compromiso<br>
                            Respeto<br>
                            Excelencia<br>
                            Integridad<br>
                        </div>

                    </div>
                </div>


                <div @click="openModalProgramaDignifica"
                    class="py-2 cursor text-programas text-gris font-dinn-regular text-center hover-div">
                    <h5>PROGRAMA DIGNIFICA</h5>
                </div>

                <div>
                    <h5 class="py-3 cursor text-programas text-gris font-dinn-regular text-center hover-div"
                        @click="openModalProgramaRecuerdame">BUENAS NOTICIAS</h5>
                </div>
                <!-- <div>
                    <h5 class="py-3 cursor text-programas text-gris font-dinn-regular text-center hover-div"
                        @click="openModalReconocimientoAsociacion">Reconocimiento
                        Asociación Nacional de
                        Directores
                        de Funerarias (NFDA, por sus siglas en inglés)</h5>

                    <h5 class="py-2 cursor text-programas text-gris font-dinn-regular text-center hover-div"
                        @click="openModalCarrozasElectricas">Carrozas eléctricas</h5>
                </div> -->


            </div>
        </div>


    </CardModalAmarilloCompleto>

    <!-- MODAL FONDO ESPERANZA -->
    <CardModalAmarilloCompleto ref="modalFondoEsperanza" background-color="#FFF" :muestra-nav="true" :tituloBlanco="false"
        :otherModalRef="modalEmpresasSociales" overflow-y="scroll" display="flex" flex-direction="column" padding="0px">

        <!-- <div class="container"> -->

        <div class="row my-1 d-flex justify-content-center align-items-center">
            <img src="../../assets/image/Sostenibilidad_Transparencia/LogoFondoEsperanza.png" class="img-fluid" alt="Logo fondo esperanza"/>
        </div>

        <div class="row text-justify p-4 fs-5">
            <p>
                Organización de desarrollo social más grande de Chile. Por más de 20 años ha sido pionera en apoyar de
                forma integral a más de 580 mil emprendedoras/es de sectores vulnerables del país que buscan desarrollar
                sus negocios y mejorar sus condiciones de vida. Estos resultados son fruto de la misión y valores que
                inspiran a nuestros 525 colaboradores, quienes cumplen día a día con el propósito de la institución.
            </p>
        </div>

        <div class="backgroundAmarillo">

            <div class="row">
                <div class="col-md-4 col-sm-12  p-4 border-height-line text-center text-white">
                    <div class="row">
                        <h5 class="font-dinn-bold fs-5">
                            <u>
                                Misión
                            </u>
                        </h5>
                    </div>

                    <div class="row">
                        <span class="font-dinn-regular text-center p-4 fs-5">
                            Inspirar a personas de sectores vulnerables a transformar sus condiciones de vida, las de
                            sus
                            familias y comunidades, ampliando sus oportunidades mediante servicios financieros,
                            capacitación
                            y redes que les permitan desarrollar emprendimientos sostenibles.
                        </span>
                    </div>

                </div>

                <div class="col-md-4 col-sm-12  p-4 border-height-line text-center text-white">
                    <div class="row">
                        <h5 class="font-dinn-bold fs-5">
                            <u>
                                Visión
                            </u>
                        </h5>
                    </div>

                    <div class="row">
                        <span class="font-dinn-regular text-center p-4 fs-5">
                            Impactar en el desarrollo social de emprendedores de sectores vulnerables, a través de un
                            modelo
                            sostenible en el tiempo, siendo la institución de microfinanzas más relevante de Chile.
                        </span>
                    </div>

                </div>

                <div class="col-md-4 col-sm-12 p-4 border-height-line text-center text-white">
                    <div class="row">
                        <h5 class="font-dinn-bold fs-5">
                            <u>
                                Valores
                            </u>
                        </h5>
                    </div>


                    <div class="row">
                        <span class="font-dinn-regular p-4 text-center fs-5">
                            La socia en el centro <br>
                            Somos un equipo <br>
                            Relaciones transparentes <br>
                            Generamos impacto social <br>
                            Aspiramos a más <br>
                        </span>
                    </div>

                </div>
            </div>

            <div @click="openModalCifrasDestacadas"
                class="py-2 cursor text-programas text-gris font-dinn-regular text-center hover-div">
                <h5>CIFRAS DESTACADAS</h5>
            </div>
            <div>
                <h5 class="py-2 cursor text-programas text-gris font-dinn-regular text-center hover-div"
                    @click="openModalQueremosDestacar">QUEREMOS DESTACAR</h5>
            </div>
            <div>
                <h5 class="py-2 cursor text-programas text-gris font-dinn-regular text-center hover-div"
                    @click="openModalReconocimientosFondoEsperanza">RECONOCIMIENTOS A FONDO ESPERANZA
                </h5>
            </div>
        </div>
        <!-- </div> -->

    </CardModalAmarilloCompleto>

    <!-- MODAL PARENTESIS HOGAR DE CRISTO -->
    <CardModalAmarilloCompleto ref="modalParentesisHogarDeCristo" :otherModalRef="modalEmpresasSociales" :muestra-nav="true"
        background-color="#FFF" overflow-y="scroll" display="flex" flex-direction="column" :tituloBlanco="false">

        <div class="col">
            <div class="row my-1 d-flex justify-content-center align-items-center">
                <img src="../../assets/image/Sostenibilidad_Transparencia/parentesis.png" class="imagen-adaptativa" alt="Logo paréntesis"/>
            </div>

            <div class="row text-justify p-4 fs-5">
                <p class="font-dinn-regular">
                    En Consultora Paréntesis nos especializamos en la implementación de programas de prevención, asesoría,
                    capacitación
                    y asistencia clínica, orientados a personas y organizaciones, buscando impactar en los ámbitos de
                    calidad de vida, salud emocional, vulnerabilidad psicosocial y consumo problemático de alcohol y drogas.

                </p>
            </div>


            <div class="backgroundAmarillo">

                <div class="row fs-5">
                    <div class="col-md-4 col-sm-12 my-2 px-4 border-height-line text-center text-white">
                        <div class="row">
                            <h5 class="font-dinn-bold">
                                <u>
                                    Visión
                                </u>
                            </h5>
                        </div>

                        <div class="row font-dinn-regular text-center px-3">
                            Proyectamos al 2030, ser la principal consultora a nivel nacional en temáticas de salud mental,
                            prevención del consumo y calidad de vida, acompañando a comunidades educativas, servicio público
                            y empresas.

                        </div>

                    </div>

                    <div class="col-md-4 col-sm-12  my-2 px-4 border-height-line text-center text-white">
                        <div class="row">
                            <h5 class="font-dinn-bold">
                                <u>
                                    Misión
                                </u>
                            </h5>
                        </div>

                        <div class="row">
                            <span class="font-dinn-regular text-center">
                                Favorecer trayectorias de vida inclusivas de las personas, fomentando su salud mental en las
                                distintas etapas del ciclo vital, fortaleciendo y acompañando a organizaciones y comunidades
                                por las que ellas transitan, a través de asesoría, difusión de conocimientos y servicios
                                clínicos de calidad.
                            </span>
                        </div>

                    </div>

                    <div class="col-md-4 col-sm-12  my-2 px-4 border-height-line text-center text-white">
                        <div class="row">
                            <h5 class="font-dinn-bold">
                                <u>
                                    Principios
                                </u>
                            </h5>
                        </div>

                        <div class="col font-dinn-regular center">
                            1. El respeto a la dignidad y naturaleza social del ser humano nos inspira<br>
                            2. Apostamos por una sociedad y comunidades que reconocen e integran la diversidad<br>
                            3. Nuestra mirada de salud integral de la persona la abordamos desde un enfoque<br>
                            multidisciplinario.
                            4. Buscamos transferir herramientas a personas y comunidades como agentes activos de cambio.<br>

                        </div>

                    </div>
                </div>


                <div @click="openModalCifrasDestacadasParentesis"
                    class="py-2 cursor text-programas text-gris font-dinn-regular text-center hover-div">
                    <h5>CIFRAS DESTACADAS</h5>
                </div>

                <div>
                    <h5 class="py-3 cursor text-programas text-gris font-dinn-regular text-center hover-div"
                        @click="openModalQueremosDestacarParentesis">QUEREMOS DESTACAR</h5>
                </div>
            </div>
        </div>


    </CardModalAmarilloCompleto>


    <!-- MODAL CIFRAS DESTACADAS -->
    <CardModalAmarilloCompleto ref="modalCifrasDestacadas" :other-modal-ref="modalFondoEsperanza" :muestra-nav="true"
        titulo="CIFRAS DESTACADAS" overflow-y="scroll" display="flex" flex-direction="column" padding="30px">
        <div class="row justify-content-center align-items-center">
            <img src="../../assets/image/CifrasDestacadasEsperanza.png" class="img-fluid" alt="Cifras destacadas"/>
        </div>
    </CardModalAmarilloCompleto>
    <!-- MODAL CIFRAS DESTACADAS PARENTESIS -->
    <ModalAmarillo ref="modalCifrasDestacadasParentesis" :other-modal-ref="modalParentesisHogarDeCristo">
        <div class="container">
            <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">CIFRAS DESTACADAS</h3>
            <img src="../../assets/image/Sostenibilidad_Transparencia/CifrasCosultoraParentesis.png" class="img-fluid" alt="Cifras destacadas paréntesis"/>
        </div>

    </ModalAmarillo>

    <!-- MODAL QUEREMOS DESTACAR -->
    <ModalAmarillo ref="modalQueremosDestacar" :other-modal-ref="modalFondoEsperanza">
        <div class="container">
            <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">QUEREMOS DESTACAR</h3>
            <CarouselComponent :informacion-carousel="informacion_carousel" />
        </div>
    </ModalAmarillo>
    <!-- MODAL QUEREMOS DESTACAR -->
    <CardModalAmarilloCompleto ref="modalQueremosDestacarParentesis" :other-modal-ref="modalParentesisHogarDeCristo"
        :muestra-nav="true" titulo="QUEREMOS DESTACAR" overflow-y="hidden" display="flex" flex-direction="column"
        padding="30px">
        <!-- FLAG -->
        <div class="container">
            <div class="row d-flex justify-content-center align-items-center">
                <img src="../../assets/image/Sostenibilidad_Transparencia/PROGRAMAORIENTA.png" class="img-fluid" alt="Programa orienta"/>
            </div>
            <p class="font-dinn-bold text-white fs-3">
                Programa Orienta:
            </p>
            <div class="text-justify text-white fs-5 font-dinn-regular">
                Es un servicio de asesoramiento, orientación y apoyo en los ámbitos psicológico, legal y nutricional. Este
                Programa es contratado por la empresa para brindar a sus colaboradores, y eventualmente familiares de los
                mismos, respuestas a sus inquietudes y problemas. Es un programa que busca prevenir y solucionar
                dificultades personales que afectan el rendimiento laboral y la calidad de vida de los trabajadores y sus
                familias.

            </div>
        </div>
    </CardModalAmarilloCompleto>

    <!-- MODAL RECONOCIMIENTOS A FONDO ESPERANZA -->
    <CardModalAmarilloCompleto ref="modalReconocimientosFondoEsperanza" :other-modal-ref="modalFondoEsperanza"
        :muestra-nav="true" titulo="RECONOCIMIENTOS A FONDO ESPERANZA" display="flex" flex-direction="column"
        padding="30px">
        <SVGReconocimientosAFondoEsperanza />
    </CardModalAmarilloCompleto>


    <!-- MODAL EMPRESAS SOCIALES -->
    <ModalAmarillo ref="modalEmpresasSociales">
        <div class="container">
            <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">NUESTRAS EMPRESAS SOCIALES</h3>
            <div @click="openModal2" class=" row cursor innerRounded my-3 d-flex justify-content-center align-items-center">
                <img src="../../assets/image/Sostenibilidad_Transparencia/Funeraria.jpg" class="imagen-adaptativa2 p-2" alt="Funeraria"/>
            </div>
            <div @click="openModalFondoEsperanza"
                class=" row cursor innerRounded my-3 d-flex justify-content-center align-items-center">
                <img src="../../assets/image/Sostenibilidad_Transparencia/LogoFondoEsperanza.png" class="img-fluid" alt="Logo fondo esperanza"/>
            </div>
            <div @click="openModalParentesisHogarDeCristo"
                class=" row cursor innerRounded my-3 d-flex justify-content-center align-items-center">
                <img src="../../assets/image/Sostenibilidad_Transparencia/parentesis.png" class="imagen-adaptativa2" alt="Paréntesis"/>
            </div>
        </div>
    </ModalAmarillo>

    <!-- MODAL PROGRAMA RECUERDAME -->
    <ModalAmarillo ref="modalProgramaRecuerdame" :other-modal-ref="modalFunerariaHogarDeCristo">
        <div class="container">
            <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">BUENAS NOTICIAS</h3>
            <h3 class="text-white text-center font-dinn-bold "> PROGRAMA RECUÉRDAME</h3>
            <div>
                <img src="../../assets/image/Sostenibilidad_Transparencia/RecuerdameGrupo.png" class="img-fluid" alt="Programa recuérdame"/>
            </div>

            <div class="text-white text-justify font-dinn-medium fs-5">
                <span>
                    Brinda oportunidades de trabajo y reinserción social a mujeres privadas de libertad. Junto al Centro
                    Penitenciario de Mujeres de Santiago y Fundación Mujer Levántate, se realizan talleres para confeccionar
                    fundas para almohadas, bolsas de impronta y otros elementos funerarios.<br>
                </span>
                <hr class="border border-white border-2 opacity-100">
            </div>
            <h3 class="text-white text-center font-dinn-bold ">
                RECONOCIMIENTO ASOCIACIÓN NACIONAL DE DIRECTORES DE
                FUNERARIAS (NFDA , por sus siglas en ingles)</h3>
            <div>
                <img src="../../assets/image/Sostenibilidad_Transparencia/Gaviota.png" class="img-fluid" alt="Asociación nacional de directores de funerarias"/>
            </div>

            <div class="text-white text-justify font-dinn-medium fs-5">
                <span>
                    Por tercer año consecutivo, Funeraria HDC obtuvo el premio NFDA, al ser una empresa que cumple con los
                    mayores estándares de calidad en el rubro funerario a nivel internacional, tanto en protocolos internos,
                    como externos.<br>
                </span>
                <hr class="border border-white border-2 opacity-100">
            </div>
            <h3 class="text-white text-center font-dinn-bold "> CARROZAS ELÉCTRICAS</h3>
            <div>
                <img src="../../assets/image/Sostenibilidad_Transparencia/Carroza.png" class="img-fluid" alt="Carrozas elétricas"/>
            </div>
            <div class="text-white text-justify font-dinn-medium fs-5">
                <span>
                    Este año adquirimos 3 carrozas de marca Nissan, modelo Leaf, 100% eléctricos, fabricados en Cataluña,
                    España. Al ser de baja contaminación se adecúan a nuestros estándares como Empresa B.

                </span>
            </div>

        </div>


    </ModalAmarillo>

    <!-- MODAL PROGRAMA DIGNIFICA -->

    <ModalAmarillo ref="modalProgramaDignifica" :other-modal-ref="modalFunerariaHogarDeCristo">
        <div class="container">
            <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">PROGRAMA DIGNIFICA</h3>
            <img src="../../assets/image/Sostenibilidad_Transparencia/mano.png" class="img-fluid" alt="Programa dignifica"/>

            <div class="text-white text-justify font-dinn-medium fs-5">
                <span>
                    Programa desarrollado en conjunto con Parque del Recuerdo para brindar apoyo y acompañamiento a familias
                    que
                    viven momentos de alta carga emocional entregando una sepultura digna y gratuita a bebés no natos y
                    mortinatos de 21 hospitales y clínicas de la RM. En el año 2021 ofrecimos 502 servicios y en 2022 un
                    total
                    565.
                </span>
            </div>
            <div>
                <img src="../../assets/image/Sostenibilidad_Transparencia/textofinal.png" class="img-fluid" alt="Texto final programa dignifica"/>
            </div>
        </div>
    </ModalAmarillo>

    <!-- MODAL CONTÁCTANOS -->

    <ModalAmarillo ref="modalContactanos">
        <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">¿TIENES DUDAS? CONTÁCTANOS</h3>
        <div class="me-2">
            <form @submit="submitForm" class="w-100">
                <p v-if="errors.length">
                    <b>Por favor, corrija el(los) siguiente(s) error(es):</b>
                <ul>
                    <li v-for="(error) in errors" :key="error">{{ error }}</li>
                </ul>
                </p>
                <div class="mb-3">
                    <input type="text" class="form-control" id="Nombre" aria-describedby="emailHelp" placeholder="Nombre"
                        v-model="nombre">
                </div>
                <div class="mb-3">
                    <input type="email" class="form-control" id="email" aria-describedby="emailHelp" placeholder="Email"
                        v-model="email">
                </div>
                <div class="mb-3">
                    <input type="text" class="form-control" id="Asunto" aria-describedby="emailHelp" placeholder="Asunto"
                        v-model="asunto">
                </div>
                <div class="mb-3">
                    <textarea class="form-control" id="formControlArea" rows="4" placeholder="Escribe aquí tu mensaje"
                        v-model="mensaje"></textarea>
                </div>
            </form>
            <div class="text-center innerRounded w-100 p-4 d-flex justify-content-center align-items-center">
                <button type="submit" @click="submitForm"
                    class="btn p-2 m-3 w-50 round-button backgroundAmarillo">ENVIAR</button>
            </div>
            <div>
                <span class="font-dinn-medium p-3 d-flex text-justify justify-content-center align-items-center">
                    <br>
                    Las Fundaciones Hogar de Cristo queremos hacer de nuestra causa un ejemplo de Transparencia. Por este
                    motivo, te
                    invitamos a efectuar aquí tu Solicitud de Información completando el siguiente formulario. Te
                    responderemos
                    en
                    un plazo máximo de 20 días hábiles.
                </span>
            </div>
        </div>
    </ModalAmarillo>

    <!-- MODAL DIRECTORIOS -->
    <ModalBlanco ref="modalDirectorios">
        <h3 class="mb-0 w-100 text-center font-dinn-bold textoAmarillo">DIRECTORIOS</h3>
        <div class="accordion me-2" id="accordionExample">
            <div class="accordion-item my-3 border-0">
                <h2 class="accordion-header" id="headingOne">
                    <button class="accordion-button collapsed text-white font-dinn-bold border-0" type="button"
                        data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne">
                        DIRECTORIO DE HOGAR DE CRISTO
                    </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body p-0">
                        <table class="table border-none p-0 m-0">
                            <tbody class="p-0 m-0">
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Alejandra Mehech Castellón</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Presidente</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Luis Ibañez Anrique</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">1er Vicepresidente
                                    </td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Carmen Gloria López Moure</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">2do Vicepresidente</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Jorge Correa Sutil</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Secretario</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Alberto Ferrán López</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Tesorero</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">José Francisco Yuraszeck s.j.</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Capellán General - Director</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">María José Zaldívar Larraín</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Directora</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Carolina Muñoz García</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Directora</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Horacio Pavez Aro</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Director</td>
                                </tr>
                                <!-- Agrega más filas aquí -->
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-3 border-0">
                <h2 class="accordion-header" id="headingTwo">
                    <button class="accordion-button collapsed text-white font-dinn-bold border-0" type="button"
                        data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false"
                        aria-controls="collapseTwo">
                        DIRECTORIO FUNDACIÓN EMPLEA DE HOGAR DE CRISTO
                    </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body p-0">
                        <table class="table border-none p-0 m-0">
                            <tbody class="p-0 m-0">
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Claudio Storm Quinteros</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Presidente</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Magdalena Aninat Salhi</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Vice-Presidente</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">María Ximena Alzérreca</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Secretaria</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Marcos Singer González</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Tesorero</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Juan Manuel Jordán</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Director</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Patricia Roa Ramírez</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Directora</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">José Francisco Yuraszeck s.j.</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Capellán</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-3 border-0">
                <h2 class="accordion-header" id="headingThree">
                    <button class="accordion-button collapsed text-white font-dinn-bold border-0" type="button"
                        data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false"
                        aria-controls="collapseThree">
                        DIRECTORIO DE FUNDACIÓN SÚMATE DE HOGAR DE CRISTO
                    </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body p-0">
                        <table class="table border-none p-0 m-0">
                            <tbody class="p-0 m-0">
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Fernando Rojas Echeverría</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Presidente</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Pablo Vaillant Castellano</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Vice-Presidente</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Magdalena Claro Tagle</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Secretaria</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Carola Venegas</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Tesorero</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Alejandra Arratia</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Directora</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">Lorenzo Gazmuri</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Director</td>
                                </tr>
                                <tr class="m-0 p-0">
                                    <td class="font-dinn-regular text-center">José Francisco Yuraszeck s.j.</td>
                                    <td class="text-center"><span class="yellow-sphere"></span></td>
                                    <td class="font-dinn-light text-center">Capellán</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </ModalBlanco>

    <!-- MODAL ESTADOS FINANCIEROS CONSOLIDADOS -->

    <ModalAmarillo ref="modalEstadosFinancieros">
        <div class="me-2">
            <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">ESTADOS FINANCIEROS CONSOLIDADOS</h3>
            <div>
                <SVGEstadosFinancierosConsolidados />
            </div>
        </div>
    </ModalAmarillo>


    <!-- MODAL FINANCIAMIENTO CORPORATIVO 2022 -->
    <ModalBlanco ref="modalFinanciamientoCorporativo">
        <div class="me-2">
            <h3 class="mb-0 w-100 text-center font-dinn-bold textoAmarillo">FINANCIAMIENTO CORPORATIVO 2022</h3>
            <picture>
                <source :srcset="require('../../assets/image/Sostenibilidad_Transparencia/FinanciamientoCorporativo.webp')" type="image/webp">
                <img src="../../assets/image/Sostenibilidad_Transparencia/FinanciamientoCorporativo.jpg" class="img-fluid" alt="Financiamiento corporativo"/>
            </picture>
        </div>

        <!-- <SVGFinanciamientoCorporativo2022 /> -->
    </ModalBlanco>

    <!-- MODAL HOGAR DE CRISTO EN PRENSA Y RRSS -->

    <ModalAmarillo ref="modalHogarDeCristoPrensaRRSS">
        <div class="row my-2 justify-content-center">
            <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">HOGAR DE CRISTO EN PRENSA Y RRSS</h3>
            <div class="col-md-6 col-sm-12 my-2 d-flex justify-content-center">
                <CardBordes @click="openModalCifrasDestacadasRRSS" id="cardCifrasDestacadasRRSS" minHeight="150px"
                    minWidth="150px" borderRadius="30px 0px 30px 0px" maxWidth="150px" maxHeight="150px">
                    <template #titulo>
                        <span class="font-dinn-bold">Cifras</span>
                        <span class="font-dinn-bold">destacadas</span>
                    </template>

                    <template #contenido>
                        <SVGCifrasDestacadasRRSS />
                    </template>

                    <template #bottom>
                        <svg id="Capa_2" data-name="Capa 2" xmlns="http://www.w3.org/2000/svg" viewBox="-0 0 258.52 23.43">
                            <g transform="translate(105,0)" id="Capa_1-2" data-name="Capa 1">
                                <polyline class="cls-3" points=".82 .76 20.47 21.73 37.66 .76" />
                            </g>
                        </svg>
                    </template>
                </CardBordes>

            </div>

            <div class="col-md-6 col-sm-12 my-2 d-flex justify-content-center">
                <CardBordes @click="openModalNoticiasDestacadas" id="cardNoticiasDestacadas" minHeight="150px"
                    minWidth="150px" borderRadius="30px 0px 30px 0px" maxWidth="150px" maxHeight="150px">
                    <template #titulo>
                        <span class="font-dinn-bold">Noticias destacadas</span>
                    </template>

                    <template #contenido>
                        <SVGNoticiasDestacadasRRSS />
                    </template>

                    <template #bottom>
                        <svg id="Capa_2" data-name="Capa 2" xmlns="http://www.w3.org/2000/svg" viewBox="-0 0 258.52 23.43">
                            <g transform="translate(105,0)" id="Capa_1-2" data-name="Capa 1">
                                <polyline class="cls-3" points=".82 .76 20.47 21.73 37.66 .76" />
                            </g>
                        </svg>
                    </template>
                </CardBordes>

            </div>



        </div>

        <div class="row my-2 justify-content-center ">
            <div class="col-md-6 col-sm-12 my-2 d-flex justify-content-center">
                <CardBordes @click="openModalHoraDeConversarRRSS" id="cardHoraDeConversar" minHeight="150px"
                    minWidth="150px" borderRadius="30px 0px 30px 0px" maxWidth="150px" maxHeight="150px">
                    <template #titulo>
                        <span class="font-dinn-bold">Hora de</span>
                        <span class="font-dinn-bold">Conversar</span>
                    </template>

                    <template #contenido>
                        <div class="container">
                            <div class="row">
                                <SVGHoraDeConversarRRSS />
                            </div>
                        </div>
                    </template>

                    <template #bottom>
                        <svg id="Capa_2" data-name="Capa 2" xmlns="http://www.w3.org/2000/svg" viewBox="-0 0 258.52 23.43">
                            <g transform="translate(105,0)" id="Capa_1-2" data-name="Capa 1">
                                <polyline class="cls-3" points=".82 .76 20.47 21.73 37.66 .76" />
                            </g>
                        </svg>
                    </template>
                </CardBordes>

            </div>
            <div class="col-md-6 col-sm-12 my-2 d-flex justify-content-center">
                <CardBordes @click="openModalPublicacionesRealizadas" minHeight="150px" minWidth="150px"
                    borderRadius="30px 0px 30px 0px" maxWidth="150px" maxHeight="150px">
                    <template #titulo>
                        <span class="font-dinn-bold">Publicaciones</span>
                    </template>

                    <template #contenido>
                        <SVGPublicacionesRRSS />
                    </template>

                    <template #bottom>
                        <svg id="Capa_2" data-name="Capa 2" xmlns="http://www.w3.org/2000/svg" viewBox="-0 0 258.52 23.43">
                            <g transform="translate(105,0)" id="Capa_1-2" data-name="Capa 1">
                                <polyline class="cls-3" points=".82 .76 20.47 21.73 37.66 .76" />
                            </g>
                        </svg>
                    </template>
                </CardBordes>
            </div>
        </div>

    </ModalAmarillo>

    <!-- MODAL NOTICIAS DESTACADAS -->
    <ModalAmarillo ref="modalNoticiasDestacadas" :other-modal-ref="modalHogarDeCristoPrensaRRSS">
        <div class=container>
            <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">NOTICIAS DESTACADAS</h3>
            <SVGNoticiasDestacadas />
        </div>

    </ModalAmarillo>

    <!-- MODAL PUBLICACIONES REALIZADAS 2022 -->
    <ModalAmarillo ref="modalPublicacionesRealizadas" :other-modal-ref="modalHogarDeCristoPrensaRRSS">
        <!-- PUBLICACIONES REALIZADAS POR LA DIRECCIÓN DE COMUNICACIONES 2022 -->
        <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">
            PUBLICACIONES REALIZADAS POR LA DIRECCIÓN DE COMUNICACIONES 2022
        </h3>

        <!-- FLAG 2 -->

        <div class="container">
            <!-- Primera publicación -->
            <div class="row bg-white roundGeneral mb-1 mx-2">
                <div class="col-12 d-flex justify-content-center">
                    <img src="../../assets/image/Sostenibilidad_Transparencia/Imagen1_PublicacionesRealizadas.jpg" alt="Publicaciones realizadas"
                        class="img-prensa-hdc">
                </div>
                <div class="col-12 text-center">
                    <div class="row my-2">
                        <span class="font-dinn-bold">10 Bacanas de Hogar de Cristo</span>
                    </div>
                    <div class="row my-2">
                        <span class="font-dinn-regular">
                            Libro que relata el testimonio de 10 mujeres que se destacan por su participación en los
                            programas
                            del Hogar de Cristo. Una de ellas es Elena Donaire, voluntaria de 93 años, que aún sale a las
                            calles
                            a dar abrigo y comida a quienes viven en vulnerabilidad.
                        </span>
                    </div>
                </div>
            </div>

            <!-- Segunda publicación -->
            <div class="row bg-white roundGeneral mt-1 mx-2">
                <div class="col-12 d-flex justify-content-center">
                    <img src="../../assets/image/Sostenibilidad_Transparencia/Imagen2_PublicacionesRealizadas.jpg" alt="Segunda publicación"
                    class="img-prensa-hdc">
                </div>
                <div class="col-12 text-center">
                    <div class="row my-2">
                        <span class="font-dinn-bold">Microrrelatos Atravesados</span>
                    </div>
                    <div class="row my-2">
                        <span class="font-dinn-regular">
                            Edición y publicación de relatos de autoría de William Ortiz, ganador dos veces del concurso
                            literario Vuelen Plumas para personas con discapacidad mental y ex participante de Hogar de
                            Cristo.
                        </span>
                    </div>
                </div>
            </div>

            <!-- Enlace a todas las publicaciones -->
            <div class="row my-2 text-center">
                <a href="https://www.hogardecristo.cl/publicaciones/" target="_blank" class="yellow-underline">
                    <span class="font-dinn-bold textoAmarillo fs-5 cursor bg-white">
                        CONOCE TODAS NUESTRAS PUBLICACIONES
                    </span>
                </a>
            </div>
        </div>


    </ModalAmarillo>

    <!-- MODAL CIFRAS DESTACADAS -->
    <ModalAmarillo ref="modalCifrasDestacadasRRSS" :other-modal-ref="modalHogarDeCristoPrensaRRSS">
        <div class="container">
            <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">CIFRAS DESTACADAS</h3>
            <div class="row">
                <SVGPublicacionesPorTematica />
            </div>

            <div class="row">
                <CarouselComponent :fondo-blanco="false" :cifras="true" :informacion-carousel="informacion_carousel_2" />
                <br>
            </div>

            <div class="row">
                <SVGPromedioMensualInteracciones />
            </div>

        </div>

    </ModalAmarillo>

    <!-- MODAL HORA DE CONVERSAR -->
    <ModalAmarillo ref="modalHoraDeConversarRRSS" :other-modal-ref="modalHogarDeCristoPrensaRRSS">
        <!-- agregar pading -->
        <div class="container">
            <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">HORA DE CONVERSAR</h3>
            <div class="row">
                <div class="col-12">
                    <span class="font-dinn-regular fs-5 text-white text-justify">
                        Hora de Conversar nace en 2020, durante la pandemia, cuando se produce un verdadero boom de los
                        webinar.
                        El
                        año 2022 fue su tercera temporada y hoy abarca todos los temas sociales del país, siempre en alianza
                        con
                        radio Cooperativa y conducido por la periodista Ximena Torres.
                    </span>
                    <hr class="border border-white border-2 opacity-100 mt-3">
                    <h1 class="p-1 text-center text-white font-dinn-bold h1-responsive">Hora de conversar</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-8 roundGeneral bg-white p-3">
                    <img src="../../assets/image/Sostenibilidad_Transparencia/HoraDeConversar1.jpg" alt="Primer hora de conversar"
                        class="img-fluid">
                </div>

                <div class="col h-50 mt-1 mt-md-2 p-2 roundGeneralTransparenteBordeBlanco">
                    <a href="https://www.youtube.com/live/GAA4SVaBIA8?feature=share" target="_blank">
                        <SVGVerCapitulo />
                    </a>
                </div>

            </div>

            <div class="row my-1">
                <div class="col-8 roundGeneral bg-white p-3">
                    <img src="../../assets/image/Sostenibilidad_Transparencia/HoraDeConversar2.jpg" alt="Segundo hora de conversar"
                        class="img-fluid">
                </div>

                <div class="col h-50 mt-1 mt-md-2 p-2 roundGeneralTransparenteBordeBlanco">
                    <a href="https://www.youtube.com/watch?v=Z3Z9hdvaAzk" target="_blank">
                        <SVGVerCapitulo />
                    </a>
                </div>

            </div>

            <div class="row my-1">
                <div class="col-8 roundGeneral bg-white p-3">
                    <img src="../../assets/image/Sostenibilidad_Transparencia/HoraDeConversar3.jpg" alt="Tercer hora de conversar"
                        class="img-fluid">
                </div>

                <div class="col h-50 mt-1 mt-md-2 p-2 roundGeneralTransparenteBordeBlanco">
                    <a href="https://www.youtube.com/watch?v=XZz6F1nkzFY" target="_blank">
                        <SVGVerCapitulo />
                    </a>
                </div>

            </div>
        </div>
    </ModalAmarillo>

    <!-- MODAL ORGANIGRAMA -->
    <ModalAmarillo ref="modalOrganigrama">
        <h3 class="mb-0 w-100 text-center font-dinn-bold textoBlanco">ORGANIGRAMA CORPORATIVO</h3>    
        <div>
            <picture>
                <source :srcset="require('../../assets/image/Sostenibilidad_Transparencia/Organigrama.webp')" type="image/webp">
                <img src="../../assets/image/Sostenibilidad_Transparencia/Organigrama.jpg" class="img-fluid" alt="Organigrama corporativo"/>
            </picture>
       </div>
   
    </ModalAmarillo>
</template>

<script setup>
import CardBordes from './Componentes_genericos/CardBordes.vue';
import CardModalAmarilloCompleto from './Componentes_genericos/CardModalAmarilloCompleto.vue';
import ModalBlanco from './Componentes_genericos/ModalBlanco.vue'
import ModalAmarillo from './Componentes_genericos/ModalAmarillo.vue'
import CarouselComponent from './Componentes_genericos/CarouselComponent.vue';
import SVGReconocimientosAFondoEsperanza from './Componentes_SVGS/SVGReconocimientosAFondoEsperanza.vue';
import SVGEstadosFinancierosConsolidados from './Componentes_SVGS/SVGEstadosFinancierosConsolidados.vue';
import SVGCifrasDestacadasRRSS from './Componentes_SVGS/SVGCifrasDestacadasRRSS.vue';
import SVGNoticiasDestacadasRRSS from './Componentes_SVGS/SVGNoticiasDestacadasRRSS.vue';
import SVGHoraDeConversarRRSS from './Componentes_SVGS/SVGHoraDeConversarRRSS.vue';
import SVGPublicacionesRRSS from './Componentes_SVGS/SVGPublicacionesRRSS.vue';
import SVGNoticiasDestacadas from './Componentes_SVGS/SVGNoticiasDestacadas.vue';
import SVGPublicacionesPorTematica from './Componentes_SVGS/SVGPublicacionesPorTematica.vue';
import SVGPromedioMensualInteracciones from './Componentes_SVGS/SVGPromedioMensualInteracciones.vue';
import SVGVerCapitulo from './Componentes_SVGS/SVGVerCapitulo.vue'

import { ref } from 'vue';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, Timestamp } from 'firebase/firestore';
const firebaseConfig = {
    apiKey: "AIzaSyCQyVy2AADoKIvVhNiQ9dBql_qpuhyGOFg",
    authDomain: "hogardecristo-dev.firebaseapp.com",
    projectId: "hogardecristo-dev",
    storageBucket: "hogardecristo-dev.appspot.com",
    messagingSenderId: "238207057332",
    appId: "1:238207057332:web:32819cbede5b6b403f46e1",
    measurementId: "G-P6MREQ1SLC"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const nombre = ref('')
const email = ref('')
const asunto = ref('')
const mensaje = ref('')
const errors = ref([])

const submitForm = async () => {
    const formData = {
        nombre: nombre.value,
        email: email.value,
        asunto: asunto.value,
        mensaje: mensaje.value,
        timestamp: Timestamp.now(),
    };

    //validate form
    errors.value = [];

    if (!formData.nombre) {
        errors.value.push('Por favor ingresa tu nombre.');
    }
    if (!formData.email) {
        errors.value.push('Por favor ingresa tu email.');
    }
    if (!formData.asunto) {
        errors.value.push('Por favor ingresa el asunto.');
    }
    if (!formData.mensaje) {
        errors.value.push('Por favor ingresa el mensaje.');
    }

    if (errors.value.length > 0) {
        return;
    }

    try {
        const docRef = await addDoc(collection(db, 'formData'), formData);
        console.log('Adding document formData:', formData, '. Written with ID:', docRef.id);
        window.alert('Mensaje enviado correctamente \n\nNos pondremos en contacto contigo');
        nombre.value = '';
        email.value = '';
        asunto.value = '';
        mensaje.value = '';
    } catch (error) {
        console.error('Error adding document:', error);
    }
}


const informacion_carousel_2 = ref(
    [{
        imagen: require('@/assets/image/Sostenibilidad_Transparencia/HDC.png'),

    },
    {
        imagen: require('@/assets/image/Sostenibilidad_Transparencia/AdultoMayor.png'),

    },
    {
        imagen: require('@/assets/image/Sostenibilidad_Transparencia/PobrezaVulneracion.png'),
    },
    {
        imagen: require('@/assets/image/Sostenibilidad_Transparencia/reinsercionEducativa.png'),
    },
    {
        imagen: require('@/assets/image/Sostenibilidad_Transparencia/Voluntariado.png'),

    },
    {
        imagen: require('@/assets/image/Sostenibilidad_Transparencia/InclusionLaboral.png'),
    },
    {
        imagen: require('@/assets/image/Sostenibilidad_Transparencia/DiscapacidadMental.png'),

    },
    {
        imagen: require('@/assets/image/Sostenibilidad_Transparencia/InfanciaVulnerada.png'),
    }
    ]
);

const informacion_carousel = ref(
    [{
        imagen: '/assets/image/Sostenibilidad_Transparencia/RegalaEsperanza.png',
        textoSuperior: '#REGALAESPERANZA',
        textoInferior: 'Concurso abierto que destaca a 52 emprendedores de Arica a  Chiloé.'
    },
    {
        imagen: '/assets/image/Sostenibilidad_Transparencia/SociasBacanas.png',
        textoSuperior: 'SOCIAS BACANAS',
        textoInferior: 'Publicación de un libro con 20 testimonios de emprendedoras en alianza con Mujeres Bacanas.'
    },
    {
        imagen: '/assets/image/Sostenibilidad_Transparencia/MujeresDeEsperanza.png',
        textoSuperior: 'MUJERES DE ESPERANZA',
        textoInferior: '10 reportajes a 10 emprendedoras en DFMás.'
    },
    {
        imagen: '/assets/image/Sostenibilidad_Transparencia/JornadaNacional.png',
        textoSuperior: 'JORNADA NACIONAL',
        textoInferior: 'Después de cuatro años, todos los equipos de Fondo Esperanza se volvieron a reunir con motivo de nuestro aniversario.'
    }]
);
const modalQueremosDestacarParentesis = ref(null);
const modalCifrasDestacadasParentesis = ref(null);
const modalParentesisHogarDeCristo = ref(null);
const modalEmpresasSociales = ref(null);
const modalFunerariaHogarDeCristo = ref(null);
const modalFondoEsperanza = ref(null);
const modalCifrasDestacadas = ref(null);
const modalQueremosDestacar = ref(null);
const modalReconocimientosFondoEsperanza = ref(null);
const modalProgramaDignifica = ref(null);
const modalProgramaRecuerdame = ref(null);
// const modalCarrozasElectricas = ref(null);
// const modalReconocimientoAsociacion = ref(null);
const modalOrganigrama = ref(null);

const modalContactanos = ref(null);
const modalDirectorios = ref(null);
const modalEstadosFinancieros = ref(null);
const modalFinanciamientoCorporativo = ref(null);
const modalHogarDeCristoPrensaRRSS = ref(null);
const modalNoticiasDestacadas = ref(null);
const modalPublicacionesRealizadas = ref(null);
const modalCifrasDestacadasRRSS = ref(null);
const modalHoraDeConversarRRSS = ref(null);

const openModalOrganigrama = () => {
    modalOrganigrama.value.openModal();
}

const openModalHoraDeConversarRRSS = () => {
    modalHogarDeCristoPrensaRRSS.value.closeModal();
    modalHoraDeConversarRRSS.value.openModal();
}

const openModalCifrasDestacadasRRSS = () => {
    modalHogarDeCristoPrensaRRSS.value.closeModal();
    modalCifrasDestacadasRRSS.value.openModal();
};

const openModalPublicacionesRealizadas = () => {
    modalHogarDeCristoPrensaRRSS.value.closeModal();
    modalPublicacionesRealizadas.value.openModal();
};

const openModalNoticiasDestacadas = () => {
    modalHogarDeCristoPrensaRRSS.value.closeModal();
    modalNoticiasDestacadas.value.openModal();
};

const openModalHogarDeCristoPrensaRRSS = () => {
    modalHogarDeCristoPrensaRRSS.value.openModal();
};

const openModalFinanciamientoCorporativo = () => {
    modalFinanciamientoCorporativo.value.openModal();
};

const openModalEstadosFinancieros = () => {
    modalEstadosFinancieros.value.openModal();
};

const openModalContactanos = () => {
    modalContactanos.value.openModal();
};

const openModalDirectorios = () => {
    modalDirectorios.value.openModal();
};

const openModalEmpresasSociales = () => {
    modalEmpresasSociales.value.openModal();
};

const openModalFondoEsperanza = () => {
    modalEmpresasSociales.value.closeModal();
    modalFondoEsperanza.value.openModal();
}


const openModalCifrasDestacadas = () => {
    modalFondoEsperanza.value.closeModal();
    modalCifrasDestacadas.value.openModal();
}

const openModalQueremosDestacar = () => {
    modalFondoEsperanza.value.closeModal();
    modalQueremosDestacar.value.openModal();
}

const openModalReconocimientosFondoEsperanza = () => {
    modalFondoEsperanza.value.closeModal();
    modalReconocimientosFondoEsperanza.value.openModal();
}

const openModalProgramaDignifica = () => {
    modalFunerariaHogarDeCristo.value.closeModal();
    modalProgramaDignifica.value.openModal();
}

const openModalProgramaRecuerdame = () => {
    modalFunerariaHogarDeCristo.value.closeModal();
    modalProgramaRecuerdame.value.openModal();
}


// const openModalReconocimientoAsociacion = () => {
//     modalFunerariaHogarDeCristo.value.closeModal();
//     modalReconocimientoAsociacion.value.openModal();
// }

// const openModalCarrozasElectricas = () => {
//     modalFunerariaHogarDeCristo.value.closeModal();
//     modalCarrozasElectricas.value.openModal();
// }

const openModal2 = () => {
    modalEmpresasSociales.value.closeModal();
    modalFunerariaHogarDeCristo.value.openModal();
};
const openModalParentesisHogarDeCristo = () => {
    modalEmpresasSociales.value.closeModal();
    modalParentesisHogarDeCristo.value.openModal();
};
const openModalCifrasDestacadasParentesis = () => {
    modalParentesisHogarDeCristo.value.closeModal();
    modalCifrasDestacadasParentesis.value.openModal();
};
const openModalQueremosDestacarParentesis = () => {
    modalParentesisHogarDeCristo.value.closeModal();
    modalQueremosDestacarParentesis.value.openModal();
};


</script>

<style scoped>

.img-prensa-hdc {
    max-width: 50%;
}
.h1-responsive {
    font-size: 2rem;
}

.custom-table {
    margin: 0;
    padding: 0;
}

.custom-table tr,
.custom-table td {
    border: none;
}

.link-button {
    text-decoration: none;
}

/* Responsive font size */
@media (max-width: 576px) {
    .accordion-button {
        padding: 1.5rem 1.25rem;
    }

    .yellow-sphere {
        width: 10px;
        height: 10px;
        margin-top: 4px;
    }

    .font-dinn-regular,
    .font-dinn-light,
    .font-dinn-bold {
        font-size: 0.8rem;
        /* Adjust based on your preference */
    }

    .roundGeneralTransparenteBordeBlanco {
        border-width: 4px !important;
    }

    .h1-responsive {
        font-size: 2rem;
    }
}

@media (max-width: 768px) {
    .font-dinn-light[style] {
        font-size: 11px !important;
    }

    .yellow-sphere {
        width: 12px;
        height: 12px;
    }
}

/* If the yellow sphere is an image or icon, ensure it scales correctly */
.yellow-sphere {
    /* If it's a fixed size, maybe add */
    width: 100%;
    max-width: 15px;
    /* Example max-width, adjust accordingly */
    height: auto;
}

/* For smaller screens, you might want to stack columns on top of each other */
@media (max-width: 576px) {

    .accordion-body .col,
    .accordion-body .col-1,
    .accordion-body .col-7 {
        flex-basis: 100%;
        max-width: 100%;
    }
}


.yellow-underline {
    text-decoration: underline;
    text-decoration-color: #ffcb00;
}

/* Estilos de las clases */
.name,
.role {
    flex-grow: 1;
    min-width: 8rem;
    /* Usa rem en lugar de px */
}

.icon {
    flex: 0 0 2.5rem;
    /* Usa rem en lugar de px */
}

.yellow-sphere {
    margin-top: 5px;
    display: inline-block;
    width: 15px;
    height: 15px;
    background-color: #ffcb00;
    border-radius: 50%;
}




.textoAmarillo {
    color: #ffcb00;
}

.textoBlanco {
    color: #FFFFFF;
}

.cls-1 {
    font-family: DINNextRoundedLTPro-Bold, 'DINNextRoundedLTPro Bold';
    font-size: 133.46px;
    font-weight: 700;
    stroke-width: .29px;
}

.cls-3 {
    letter-spacing: .05em;
}

.cls-1 {
    fill: #737373;
    font-family: DINNextRoundedLTPro-Medium, 'DINNextRoundedLTPro Medium';
    font-size: 35.03px;
    font-weight: 500;
}

.cls-2 {
    fill: #ffcb00;
}


.cls-3 {
    fill: none;
    stroke: #fff;
    stroke-miterlimit: 10;
    stroke-width: 2.24px;
}

.text-gris {
    color: #6E6E6E !important;
}

.hover-div {
    width: 100%;
    border-radius: 0 0 50px 0;
    transition: background-color 0.1s ease;
}

.hover-div:hover {
    color: #ffcb00 !important;
    border-radius: 0 0 50px 0;
    background-color: #ffffff;
}

.text-justify {
    text-align: justify;
}

.form-control {
    border-radius: 18px;
}

.cls-21 {
    font-family: DINNextRoundedLTPro-Bold, 'DINNextRoundedLTPro Bold';
    font-weight: 700;
}

.cursor {
    cursor: pointer;
}

.text-programas {
    font-family: DINNextRoundedLTPro-Regular, 'DINNextRoundedLTPro Regular';
}


.roundGeneral {
    border-radius: 45px 0 45px 0;
}

.roundEspecial {
    border-radius: 50px 0 0 0;
}

.round-button {
    border-radius: 15px 0 10px 0;
}

.border-height-line {
    border-image: linear-gradient(transparent 10%, rgb(255, 255, 255) 10% 90%, transparent 90%) 0 0 0 1 / 1px;
}

.roundGeneralTransparenteBordeBlanco {
    border-radius: 0px 0 50px 0;
    border-width: 8px;
    border-style: solid;
    border-color: #FFF;
    border-left: none;
    transform: translate(-10px);
}

.roundBordeDerechoAbajo {
    border-radius: 0 0 45px 0;
}

.backgroundBlanco {
    background-color: #FFF;
    margin: 0;
    padding: 0;
}

.accordion-button {
    background-color: #ffcb00;
    border-radius: 25px 0 25px 0 !important;
}

.backgroundAmarillo {
    background-color: #ffcb00;
    margin: 0;
    padding: 0;
}

.textoAmarillo {
    color: #feca05;
}

.imagen-adaptativa {
    width: 60%;
    height: 60%;
    object-fit: cover;
    /* Asegura que la imagen cubra todo el contenedor sin deformarse */
    object-position: center;
    /* Alinea la imagen al centro del contenedor */
}

.imagen-adaptativa2 {
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: auto;
    width: 190px;
}

.container-cards {
    padding-top: 10%;
}

.innerRounded {
    border-radius: 45px 0 45px 0;
    min-height: 100px;
    background-color: #FFF;
    position: relative;
    width: 100%;
    /* Ajusta el ancho del contenedor según lo necesites */
    height: 100%;
    /* Ajusta la altura del contenedor según lo necesites */
    overflow: hidden;
    /* Esconde cualquier parte de la imagen que exceda los límites del contenedor */
}

.uuid-5f0897df-a5d2-4558-a19f-7232d687442d {
    fill: #feca05;
}

.uuid-dc964b81-da77-4462-9a86-21a3162e92db {
    fill: none;
    stroke: #fff;
    stroke-miterlimit: 10;
    stroke-width: 2.24px;
}

.uuid-90603203-e2c2-484c-9dac-ece2ed120511 {
    font-family: DINNextRoundedLTPro-Medium, 'DIN Next Rounded LT Pro';
    font-size: 45.03px;
    font-weight: 500;
}

.uuid-90603203-e2c2-484c-9dac-ece2ed120511,
.uuid-b82aded0-f015-4443-96f3-d19ff68c670c {
    fill: #737373;
}

.uuid-bf0c1c78-b592-4a41-992b-c9689c3cbb36 {
    fill: #f5f5f5;
    opacity: .6;
}

.uuid-af1a7059-57c5-46ee-98ff-5b1d8399c7be {
    letter-spacing: -.02em;
}

.uuid-20cf6563-804b-4a70-9a16-2ac8b3e648a9 {
    letter-spacing: -.02em;
}

.uuid-52e1e628-b2fe-444d-98f2-b4fa5b3486f0 {
    fill: #feca05;
}

.uuid-b28c956f-bcd1-4f02-8297-22ae4ce4d79b {
    letter-spacing: 0em;
}

.uuid-fbc34c8f-b24a-4b58-b3fa-8458a5000695 {
    fill: none;
    stroke: #fff;
    stroke-miterlimit: 10;
    stroke-width: 2.24px;
}

.uuid-2a76059c-8e72-4447-b9db-e4eb1c63edcd {
    font-family: DINNextRoundedLTPro-Medium, 'DIN Next Rounded LT Pro';
    font-size: 45.03px;
    font-weight: 500;
}

.uuid-2a76059c-8e72-4447-b9db-e4eb1c63edcd,
.uuid-105b6714-0841-41f5-8823-d09004c95d0f {
    fill: #737373;
}

.uuid-90ec77df-f487-4ca1-a17f-013270c6d0c3 {
    fill: #f5f5f5;
    opacity: .6;
}

.uuid-c56af774-3681-4842-811d-111494647cd2 {
    letter-spacing: 0em;
}

.uuid-9b315fcd-983d-4e2e-a777-aef0331598a2 {
    letter-spacing: -.02em;
}

.uuid-e3b0de1a-37c9-4e81-9612-8c8d38d1f96a {
    letter-spacing: -.02em;
}

.uuid-b1a00840-d9d6-45e1-bf9e-b3cfcc277851 {
    fill: #feca05;
}

.uuid-b423dafd-3f17-4893-a2c5-a84087652142 {
    fill: none;
    stroke: #fff;
    stroke-miterlimit: 10;
    stroke-width: 2.24px;
}

.uuid-a4bbbc48-01c3-4327-996f-9b749020f892 {
    font-family: DINNextRoundedLTPro-Medium, 'DIN Next Rounded LT Pro';
    font-size: 45.03px;
    font-weight: 500;
}

.uuid-a4bbbc48-01c3-4327-996f-9b749020f892,
.uuid-aedab406-19e8-451a-b1d3-fc0e7e4a2660 {
    fill: #737373;
}

.uuid-f4afe87d-6934-4bb1-9b2f-5622979a76f0 {
    fill: #f5f5f5;
    opacity: .6;
}

.uuid-32cbca73-b069-4022-a624-019c9e596710 {
    letter-spacing: 0em;
}

.uuid-fb2b9782-6f02-4fef-950c-8f8559e1457b {
    fill: #feca05;
}

.uuid-69ea9095-63a1-4ef2-aaa9-600e8e9f3ced {
    fill: none;
    stroke: #fff;
    stroke-miterlimit: 10;
    stroke-width: 2.24px;
}

.uuid-ddc314bd-0eb1-42c8-bc17-f1f41993118a {
    font-family: DINNextRoundedLTPro-Medium, 'DIN Next Rounded LT Pro';
    font-size: 45.03px;
    font-weight: 500;
}

.uuid-ddc314bd-0eb1-42c8-bc17-f1f41993118a,
.uuid-8eaf6ed4-d7ff-4a72-9f89-e0ccde568c9a {
    fill: #737373;
}

.uuid-4d3ded23-06e6-43fc-85fd-e7cbc82d2d74 {
    fill: #f5f5f5;
    opacity: .6;
}

.uuid-a40202d7-779f-4057-9b25-4a480bb0eca4 {
    letter-spacing: -.02em;
}

.uuid-d1c69a45-16e3-4c5b-ab4b-06985541e2b1 {
    fill: #feca05;
}

.uuid-15a6d177-0c65-4b24-b5f8-e6000ad4c278 {
    fill: none;
    stroke: #fff;
    stroke-miterlimit: 10;
    stroke-width: 2.24px;
}

.uuid-c89035a2-9002-4905-aa50-0ac7b8a16920 {
    font-family: DINNextRoundedLTPro-Medium, 'DIN Next Rounded LT Pro';
    font-size: 46.56px;
    font-weight: 500;
}

.uuid-c89035a2-9002-4905-aa50-0ac7b8a16920,
.uuid-78127f83-a1e4-46c4-9b10-fa16ca637779 {
    fill: #737373;
}

.uuid-2e7059b9-b1f4-4ddf-bb8d-b3d3d801ef68 {
    fill: #f5f5f5;
    opacity: .6;
}

.uuid-f96e77b3-d705-404d-9e8e-481c749e714e {
    letter-spacing: -.02em;
}

.uuid-699c3146-2f27-41a1-a053-2b44a4dcd9cd {
    letter-spacing: 0em;
}

.uuid-0f00994f-603b-4d4b-aea7-f962d7bb0b32 {
    fill: #feca05;
}

.uuid-f5a27c19-dfb1-494a-8638-1fb0b55c81bd {
    fill: none;
    stroke: #fff;
    stroke-miterlimit: 10;
    stroke-width: 2.24px;
}

.uuid-d6a26b26-1e31-494a-b04f-43ad1c9c7a43 {
    font-family: DINNextRoundedLTPro-Medium, 'DIN Next Rounded LT Pro';
    font-size: 46.56px;
    font-weight: 500;
}

.uuid-d6a26b26-1e31-494a-b04f-43ad1c9c7a43,
.uuid-07a3998a-7cc5-4824-b1e4-5dcfd00ba8c7 {
    fill: #737373;
}

.uuid-be203a02-023d-404d-86a6-2763f79933c6 {
    fill: #f5f5f5;
    opacity: .6;
}

.uuid-2d13bd57-7b58-4864-ac4f-5b215300cfed {
    letter-spacing: -.02em;
}

.uuid-702cc2e3-9582-4a25-ac67-ce06799f52f9 {
    letter-spacing: -.04em;
}

.uuid-19d7e5f7-e1c9-4e2c-9afd-3ea672066162 {
    letter-spacing: 0em;
}

.uuid-d357ddef-3ed2-4d66-af7b-7d1d908c3e61 {
    font-family: DINNextRoundedLTPro-Medium, 'DIN Next Rounded LT Pro';
    font-size: 29.86px;
    font-weight: 500;
}

.uuid-d357ddef-3ed2-4d66-af7b-7d1d908c3e61,
.uuid-dc964737-0dc6-4e68-ad1b-8bc28c25d4a9 {
    fill: #737373;
}

.uuid-f1954807-b076-406d-8c48-414df648757c {
    fill: #ffc800;
}

.uuid-438bd32b-9f03-46f2-aaf1-738d518f2313 {
    letter-spacing: 0em;
}

.uuid-83365aae-c685-429b-b029-1fa3291fe21d {
    letter-spacing: -.02em;
}

.uuid-9e61f343-45a6-4188-88f2-54d21b501b26 {
    letter-spacing: 0em;
}</style>